import { React, useState, useEffect, useRef, useContext } from "react";
import styled from "styled-components";
import {
  RightLayoutContainer,
  PageTitleComp,
  TableLayoutData,
  DownArrowDraw,
  DetailFields,
  HaberForm,
} from "../../styledElements";
import {
  Button,
  PageHeader,
  Table,
  Tooltip,
  Progress,
  Checkbox,
  Input,
  Select,
  Row,
  Form,
  Col
} from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { Styled } from "../../pageStyled";
// import ReviewSelectedOrderDrawer from "../DeckleOrderDrawer/reviewSelectedOrderDrawer";
import ReviewSelectedHeader from "./reviewSelectedOrderHeader";
import ViewDeckleOrder from "../DeckleOrderDrawer/viewDeckleOrder";
import { cancelJobCard, deleteGroup, editToleranceForOrderSummary } from "../../../Services/deckleMatchServices";
import moment from "moment";

import {
  getOrdersData,
  getOrdersList,
  getPosData,
  addOrRemoveOrdersFromGroup,
  updateOrder,
  editQtyToBePlannedForReviewOrder,
  changePriorityofGroupOrder,
  getOrdersListForCreateNewSol,

} from "../../../Services/orderServices";
import { getProductsData } from "../../../Services/productServices";
import { useLocation, useSearchParams, useNavigate } from "react-router-dom";
import ConfirmationModal from "../../../Components/Modal/ConfirmationModal";
import warning from "../../../Assets/Icons/warning.png";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import {
  getMergeGroupsData,
  setMergeGroupsData,
} from "../../../Services/mergeGroupServices";
import { setFormObject } from "../../../Services/formServices";
// import {
//   lengthUnit,
//   weightUnit,
//   currency_List,
// } from "../../../Utils/Constant/MeasurementUnitList.jsx";
import {
  orderDim_Rewinder_Unit_Conversion,
  weight_Unit_Conversions,
  CoversionFactorCMToUnits,
  lengthUnit,
  weightUnit,
  CoversionFactorUnitsToCM,
  conversionFactorTonneToUnits,
  currency_List,
  conversionFactorUnitsToTonne,
} from "../../../Utils/Constant/MeasurementUnitList";
import ReelCoreEditModal from "../../../Components/Modal/ReelCoreEditModal";
import TableShimmer from "../../../Components/TableShimmer/tableShimmer";
import { toHandlePOName } from "../../../Utils/helper/helper";
import JobCardDataContext from "../../../ContextApi/JobCardDataContext";
import SearchContainer from "../../../Components/SearchBarHeader/searchBar";
import OrderFilter from "../../../Components/OrderFilter/Filter";
import EmptyState from "../../../Components/EmptyState/emptyState";
import emptyState_NoData from "../../../Assets/Images/emptyState_NoData.svg";
import emptyState_ConnectionAPIError from "../../../Assets/Images/emptyState_ConnectionAPIError.svg";
import emptyState_Search from "../../../Assets/Images/emptyState_Search.svg";
import { getWorkflowSettings } from "../../../Services/workFlowSettingsServices";
import { getUnitData } from "../../../Services/measurementService";
import { JobCardReelODEditModal } from "../../../Components/Modal/JobCardReelODEditModal";

const SelectStyle = styled.div`
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border: none;
    margin-top: 10px;
  }
  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    padding-left: 3px;
    padding-right: 10px;
  }
`;

const OrderDetails = styled.div`
  .pendingDetailsStyle {
    display: block;
    text-align: right;
    padding-bottom: 16px;
    font-size: 14px;
    font-family: var(--sf-pro-display-m);
    color: var(--theme-color);
    line-height: 16px;
  }
  .pendingOrderStyle {
    padding-right: 20px;
  }
`;

const filterType = [
  { label: "All", value: "all" },
  { label: "Unselected", value: "unselected" },
  // { label: "Recently Added", value: "recently_added" },
  // { label: "Recently Removed", value: "recently_removed" },
];

const ReviewSelectedOrdersData = (props) => {
  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("user-details"))
  );
  const [settingsData, setSettingsData] = useState(
    JSON.parse(localStorage.getItem("setting-data"))
  );
  const {
    orderSummaryTable,
    handleResetAll,
    stopCancelled,
    setStopCancelled,
    setOrderSummaryTable,
    setAcceptedJCGrpCode
  } = useContext(JobCardDataContext);
  const location = useLocation();

  const machineData = location.state.body;
  const groupId = location?.state?.groupId;
  const [ordersList, setOrdersList] = useState([]);
  const [ReviewSelectedOrder, setReviewSelectedOrder] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [orderIdList, setOrderIdList] = useState(location?.state?.orders);
  const [quantity, setQuantity] = useState(location?.state?.quantity);
  const [viewCancelModal, setViewCancelModal] = useState(false);
  const [tableContent, setTableContent] = useState([]);
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [finalData, setFinalData] = useState(location?.state?.data);
  const history = useNavigate();
  const nextClickRef = useRef(false);
  const isCancelJobCard = useRef(true);
  const [selectedRecord, setSelectedRecord] = useState();
  const [errorMessage, setErrorMessage] = useState("");
  const { Option } = Select;
  const [rendering, setRendering] = useState(false);
  const [selectedQty, setSelectedQty] = useState(
    0
  );
  const [grainType, setGrainType] = useState();
  const [editPlannedQty, setEditPlannedQty] = useState();
  const [isSaveButtonVisible, setIsSaveButtonVisible] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const [pendingWeightsArray, setPendingWeightsArray] = useState([]);
  const [selectedType, setSelectedType] = useState();
  const [selectedIndex, setSelectedIndex] = useState();
  const [editReelCoreModal, setEditReelCoreModal] = useState(false);
  const [reelODType, setReelODType] = useState();
  const [minReelOD, setMinReelOD] = useState();
  const [maxReelOD, setMaxReelOD] = useState();
  const [reelODUnit, setReelODUnit] = useState({});
  const [reelOD, setReelOD] = useState([]);
  const [newGroupData, setNewGroupData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const isBackClick = useRef(false);
  const [visibleToaster, setVisibleToaster] = useState(false);
  const [actionToaster, setActionToaster] = useState({
    error: "",
    msg: "",
  });
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [clearSearch, setClearSearch] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [filterTags, setFilterTags] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [emptyStateLabel, setEmptyStateLabel] = useState();
  const [emptyStatePropsData, setEmptyStatePropsData] = useState();
  const [paginationParams, setPaginationParams] = useState({
    page: 1,
    size: settingsData?.settings?.default_page_size || 10,
    sort_by: "updated_at",
    sort_type: "ascending",
  });
  const [tableRerender, setTableRerender] = useState(false);
  const [unselectedOrders, setUnselectedOrders] = useState(
    location.state.unselectedOrders?.[groupId]
  );
  const [selectedState, setSelectedState] = useState("all");
  const [totalRecords, setTotalRecords] = useState();
  const [action, setAction] = useState('view');
  const [totalOrders, setTotalOrders] = useState('');
  const [deleteModal, setDeleteModal] = useState(false);
  const [orderManagementSettings, setOrderManagementSettings] = useState(JSON.parse(localStorage.getItem("order-management-settings")));
  //state variable for showing edit toleranc form
  const [editTolerance, setEditTolerance] = useState(false);
  const [lowerTolerance, setLowerTolerance] = useState();
  const [upperTolerance, setUpperTolerance] = useState();
  //this for set the column to be edited
  const [editColumn, setEditColumn] = useState();
  const [selectedWeightUnit, setSelectedWeightUnit] = useState();
  const [unitData, setUnitData] = useState();
  const [isReelEditClicked, setReelIsEditClicked] = useState({});
  const lowerBoundRef = useRef();
  const upperBoundRef = useRef();

  const titleRef = useRef(null);
  const [stickyOffsets, setStickyOffsets] = useState({ title: 58, table: 110 });

  useEffect(() => {
    const observer = new ResizeObserver(() => {
      const baseTop = 58;
      const titleHeight = titleRef.current?.offsetHeight || 0;

      setStickyOffsets({
        title: baseTop,
        table: baseTop + titleHeight
      });
    });

    if (titleRef.current) observer.observe(titleRef.current);

    return () => observer.disconnect();
  }, [tableContent]);

  const showToaster = () => {
    setVisibleToaster(true);
    setTimeout(() => setVisibleToaster(false), 2000);
  };
  const [form] = Form.useForm();
  const [isEditQtyPlanned, setIsEditQtyPlanned] = useState(false);
  const [plannedReelErr, setPlannedReelErr] = useState({});
  const [viewConfirmGroupModal, setViewConfirmGroupModal] = useState(false);
  const [isJobCardReelODEditModalVisible, setIsJobCardReelODEditModalVisible] =
    useState(false);
  const [showAlert, setShowAlert] = useState({
    isGlobalReelODChanged: false,
    isReelODChanged: false,
    isReelOrderChanged: false
  });
  const [globalReelOD, setGlobalReelOD] = useState({
    level: "Order",
    type: "",
    min_reel_od: 0,
    max_reel_od: 0,
    unit: "",
    selectedReelOD: [],
  })

  const columnBlacklist = settingsData?.settings?.orders_page?.tables?.group_orders || [];
  const format = settingsData?.settings?.product_spec?.format || "";
  const grainTypeData = [
    { label: "Long", value: "long" },
    { label: "Short", value: "short" },
  ];
  const onGrainChange = (e, { ...record }, index) => {
    setSelectedRecord({ ...record });
    setGrainType(e);
    setSelectedIndex(index);
    // let selected = selectedRecord;

    // setTableRerender(true);
  };
  const showReviewSelectedOrder = () => {
    setReviewSelectedOrder(true);
  };
  const onCloseFullReviewSelectedOrder = () => {
    setReviewSelectedOrder(false);
  };
  const onCloseReviewSelectedOrder = () => {
    setReviewSelectedOrder(false);
  };

  const handleActions = (record) => {
    setSelectedOrder(record);
    showReviewSelectedOrder();
  };

  const closeEditReelCoreModal = () => {
    setEditReelCoreModal(false);
  };

  const capitalize = (item) => item?.charAt(0).toUpperCase() + item?.slice(1);

  const showCancelModal = () => {
    setViewCancelModal(true);
  };

  const closeCancelModal = () => {
    setViewCancelModal(false);
  };

  const confirmEditReelCoreModal = (e) => {
    // console.log(e);
    setIsEditQtyPlanned(false);
    setEditReelCoreModal(false);
    if (!editPlannedQty)
      setEditPlannedQty(e.orderData.plannedQuant.split(" ")[0]);
    let minReelOD, maxReelOD, reelODUnit, reelOD;
    if (e.reel_type === "range") {
      minReelOD = e.minimum_reel_od;
      maxReelOD = e.maximum_reel_od;
      reelODUnit = e.units;
    } else {
      reelOD = e.outer_dia;
    }
    const reelData = {
      reelODType: e.reel_type,
      minReelOD: minReelOD,
      maxReelOD: maxReelOD,
      reelOD: reelOD,
      reelODUnit: reelODUnit,
    };
    handleSave(e.orderData, 1, reelData);
  };
  const confirmCancelModal = () => {
    history("../job-cards");
    setViewCancelModal(false);
    setFormObject(null);
  };


  const calculatePlannedWeight = (
    data,
    size,
    bulk,
    reelOd,
    coreOd,
    plannedReels
  ) => {
    const value =
      (3.14 *
        parseFloat(size) *
        (Math.pow(parseFloat(reelOd), 2) - Math.pow(parseFloat(coreOd), 2)) *
        parseFloat(plannedReels)) /
      (1000 * 1000 * parseFloat(bulk) * 4);
    let plannedWeightValue = parseFloat(
      value * conversionFactorTonneToUnits[data?.units?.planned_weight]
    )?.toFixed(3);
    return plannedWeightValue;
  };

  const calculatePlannedWeightByChangedPlannedReel = async (
    index,
    data,
    orderQuantity,
    reelOd,
    coreOd,
    plannedReel
  ) => {
    let calculatedPlannedWt;
    let currentPlannedWeight;
    if (
      reelOd != "-" &&
      reelOd &&
      reelOd?.length == 1 &&
      coreOd != "-" &&
      coreOd &&
      data.width
    ) {
      calculatedPlannedWt = plannedWeightCalculation(
        index,
        data,
        orderQuantity,
        reelOd,
        coreOd,
        plannedReel
      );
    } else if (
      (!coreOd || (!reelOd && !reelOd?.length)) &&
      data.type == "Sheet"
    ) {
      if (data.type == "Sheet" && data.quantity_type === "weight") {
        if (orderQuantity) {
          calculatedPlannedWt = parseFloat(orderQuantity).toFixed(3);
        } else {
          calculatedPlannedWt = 0;
        }
      } else {
        let weightUnit = data?.units?.planned_weight;

        let dimensionUnit = data?.units?.width;
        let conversionValue = orderDim_Rewinder_Unit_Conversion[dimensionUnit];

        let length_Value = data.length * conversionValue;
        let width_Value = data.width * conversionValue;

        const value =
          (length_Value *
            width_Value *
            orderQuantity *
            data?.product_info?.gsm) /
          (10000 * 1000000);
        let plannedWeightValue =
          value * conversionFactorTonneToUnits[weightUnit];
        calculatedPlannedWt = plannedWeightValue
          ? plannedWeightValue.toFixed(3)
          : 0;
      }
    } else {
      calculatedPlannedWt = 0;
    }

    let dataSourceCopy = [...tableContent];
    let record = dataSourceCopy.find((item) => data.orderno == item.orderno);
    let calculatedNetPrice;
    let requiredWeightValue;
    if (data?.product_info) {
      let plannedWtConversion;
      let unitPlaceholder = data.units?.planned_weight;
      let priceUnit = data?.units?.per_weight_unit;
      if (data.quantity_type == "weight") {
        requiredWeightValue = data.weight.split(' ')[0];
      } else {
        requiredWeightValue = calculatedPlannedWt ? calculatedPlannedWt : 0;
      }
      if (unitPlaceholder?.toLowerCase() !== priceUnit?.toLowerCase()) {
        let unitToTonneConv =
          requiredWeightValue * weight_Unit_Conversions[unitPlaceholder];
        plannedWtConversion =
          unitToTonneConv * conversionFactorTonneToUnits[priceUnit];
      } else {
        plannedWtConversion = requiredWeightValue;
      }
      calculatedNetPrice =
        parseFloat(data.price) * parseFloat(plannedWtConversion)
          ? (parseFloat(data.price) * parseFloat(plannedWtConversion))?.toFixed(
            3
          )
          : "";
    }

    if (coreOd && reelOd && reelOd.length == 1) {
      record.calculatedreels = parseFloat(plannedReel)?.toFixed(3);
      record.rewinderreels = Math.round(parseFloat(plannedReel)?.toFixed(3))
        ? Math.round(parseFloat(plannedReel * 1)?.toFixed(3))
        : 1;
    } else {
      if (data.type == "Reel" && data.quantity_type === "reel_sheet") {
        record.calculatedreels = plannedReel;
        record.rewinderreels = plannedReel;
      } else {
        record.calculatedReels = plannedReel;
        record.rewinderreels = plannedReel;
      }
    }
    // let currentPlannedWeight = (totalWeight - record.plannedweight.split(" ")[0]) + calculatedPlannedWt;
    // setTotalWeight(currentPlannedWeight);
    record.plannedWeight =
      parseFloat(calculatedPlannedWt) +
      " " +
      capitalize(weightUnit[record?.units?.planned_weight]?.displayName);
    record.plannedQuant = (orderQuantity);
    record.net_price = calculatedNetPrice;
    const dataIndex = dataSourceCopy.findIndex(item => item.orderno === data.orderno);

    dataSourceCopy[dataIndex] = { ...record };

    // if (orderType == "other_orders") {
    //   let selectedDataCopy = [...selectedDataRows];
    //   let selectedDataIndex = selectedDataRows?.findIndex(
    //     (ele) => ele.id == data.orderno
    //   );
    //  // let selectedOrderRow = selectedDataCopy[selectedDataIndex];
    //   if (selectedOrderRow) {
    //     if (coreOd && reelOd && reelOd.length == 1) {
    //       currentPlannedWeight =
    //         totalRef.current -
    //         (tableData[index].plannedweight != "-" &&
    //         tableData[index].plannedweight != ""
    //           ? parseFloat(tableData[index].plannedweight.split(" ")[0]) *
    //             conversionFactorUnitsToTonne[
    //               tableData[index].units.planned_weight
    //             ] *
    //             conversionFactorTonneToUnits[
    //               unitData.units_management.weight.default
    //             ]
    //           : 0) +
    //         parseFloat(
    //           calculatedPlannedWt *
    //             conversionFactorUnitsToTonne[
    //               tableData[index].units.planned_weight
    //             ] *
    //             conversionFactorTonneToUnits[
    //               unitData.units_management.weight.default
    //             ]
    //         );
    //      // setTotalWeight(currentPlannedWeight < 0 ? 0 : currentPlannedWeight);
    //       // totalRef.current =
    //       //   currentPlannedWeight < 0 ? 0 : currentPlannedWeight;
    //       // selectedOrderRow.calculatedreels =
    //       //   parseFloat(plannedReel)?.toFixed(3);
    //       // selectedOrderRow.rewinderreels = Math.round(
    //       //   parseFloat(plannedReel)?.toFixed(3)
    //       // )
    //       //   ? Math.round(parseFloat(plannedReel * 1)?.toFixed(3))
    //         //: 1;
    //     } else {
    //       currentPlannedWeight =
    //         totalRef.current -
    //         (data != "-" &&
    //         data != ""
    //           ? parseFloat(data.split(" ")[0]) *
    //             conversionFactorUnitsToTonne[
    //               data.units.planned_weight
    //             ] *
    //             conversionFactorTonneToUnits[
    //               unitData.units_management.weight.default
    //             ]
    //           : 0) +
    //         parseFloat(
    //           calculatedPlannedWt *
    //             conversionFactorUnitsToTonne[
    //               data.units.planned_weight
    //             ] *
    //             conversionFactorTonneToUnits[
    //               unitData.units_management.weight.default
    //             ]
    //         );
    //       // setTotalWeight(currentPlannedWeight < 0 ? 0 : currentPlannedWeight);
    //       // totalRef.current =
    //       //   currentPlannedWeight < 0 ? 0 : currentPlannedWeight;
    //       if (data.type == "Reel" && data.quantity_type === "reel_sheet") {
    //         selectedOrderRow.calculatedreels = plannedReel;
    //         selectedOrderRow.rewinderreels = plannedReel;
    //       } else {
    //         selectedOrderRow.calculatedReels = plannedReel;
    //         selectedOrderRow.rewinderreels = plannedReel;
    //       }
    //     }
    //     selectedOrderRow.plannedweight =
    //       parseFloat(calculatedPlannedWt) +
    //       " " +
    //       capitalize(weightUnit[record?.units?.planned_weight]?.displayName);
    //     selectedOrderRow.plannedQuant = parseFloat(orderQuantity);
    //     selectedOrderRow.net_price = calculatedNetPrice;
    //     if (data.id_od_type == "range") {
    //       selectedOrderRow.maximum_reel_od = data.maximum_reel_od;
    //       selectedOrderRow.minimum_reel_od = data.minimum_reel_od;
    //     } else {
    //       selectedOrderRow.outer_dia = data.outer_dia;
    //       selectedOrderRow.reelod = data.reelod;
    //     }
    //     selectedOrderRow.inner_dia = data.inner_dia;
    //     selectedOrderRow.coreid = data.coreid;

    //     selectedDataCopy[selectedDataIndex] = { ...selectedOrderRow };

    //     setSelectedDataRows([...selectedDataCopy]);
    //   }
    // } else {
    //   let selectedDataCopy = [...selectedDataRows];
    //   let selectedDataIndex = selectedDataRows?.findIndex(
    //     (ele) => ele.id == data.orderno
    //   );
    //   let selectedOrderRow = selectedDataCopy[selectedDataIndex];
    //   if (selectedOrderRow) {
    //     if (coreOd && reelOd && reelOd.length == 1) {
    //       currentPlannedWeight =
    //         totalRef.current -
    //         (tableData[index].plannedweight != "-" &&
    //         tableData[index].plannedweight != ""
    //           ? parseFloat(tableData[index].plannedweight.split(" ")[0]) *
    //             conversionFactorUnitsToTonne[
    //               tableData[index].units.planned_weight
    //             ] *
    //             conversionFactorTonneToUnits[
    //               unitData.units_management.weight.default
    //             ]
    //           : 0) +
    //         parseFloat(
    //           calculatedPlannedWt *
    //             conversionFactorUnitsToTonne[
    //               tableData[index].units.planned_weight
    //             ] *
    //             conversionFactorTonneToUnits[
    //               unitData.units_management.weight.default
    //             ]
    //         );
    //       setTotalWeight(currentPlannedWeight < 0 ? 0 : currentPlannedWeight);
    //       totalRef.current =
    //         currentPlannedWeight < 0 ? 0 : currentPlannedWeight;
    //     } else {
    //       currentPlannedWeight =
    //         totalRef.current -
    //         (tableData[index].plannedweight != "-" &&
    //         tableData[index].plannedweight != ""
    //           ? parseFloat(tableData[index].plannedweight.split(" ")[0]) *
    //             conversionFactorUnitsToTonne[
    //               tableData[index].units.planned_weight
    //             ] *
    //             conversionFactorTonneToUnits[
    //               unitData.units_management.weight.default
    //             ]
    //           : 0) +
    //         parseFloat(
    //           calculatedPlannedWt *
    //             conversionFactorUnitsToTonne[
    //               tableData[index].units.planned_weight
    //             ] *
    //             conversionFactorTonneToUnits[
    //               unitData.units_management.weight.default
    //             ]
    //         );
    //       setTotalWeight(currentPlannedWeight < 0 ? 0 : currentPlannedWeight);
    //       totalRef.current =
    //         currentPlannedWeight < 0 ? 0 : currentPlannedWeight;
    //     }
    //   }
    // }

    //tableDataRef.current = [...dataSourceCopy];
    let odType, reelUnit, reelod;
    odType = record.od_type;
    if (record.id_od_type === "range") {
      reelod = {
        minimum_reel_od: record.minimum_reel_od,
        maximum_reel_od: record.maximum_reel_od,
      };
      reelUnit = {
        minimum_reel_od: record?.units?.minimum_reel_od,
        maximum_reel_od: record?.units?.maximum_reel_od,
      };
    } else {
      reelod = record.outer_dia;
    }

    let requestBody = {
      order_id: selectedRecord?.orderno,
      planned_weight:
        parseFloat(record.plannedWeight.split(' ')[0]),
      group_id: location.state.groupId,
      reel_od: reelod,
      od_type: odType,
      cutter_reel_dia: false,
      quantity: record.rewinderReels,
      units: {
        planned_weight: selectedRecord.units?.planned_weight,
        minimum_reel_od: reelUnit?.minimum_reel_od,
        maximum_reel_od: reelUnit?.maximum_reel_od,
      },
    };

    await editQtyToBePlannedForReviewOrder(requestBody)
      .then((response) => {
        if (showAlert.isGlobalReelODChanged) {
          setShowAlert((prev) => ({
            ...prev,
            isReelODChanged: true,
          }))
        }
        setNewGroupData(response.data.group_data);
        const groups = orderSummaryTable.state.data.groups;
        const selectedGroup = groups.map((group) => group.id === location.state.groupId ? response.data.group_data : group);

        setOrderSummaryTable((prevState) => ({
          ...prevState,
          state: {
            ...prevState?.state,
            data: {
              ...prevState?.state.data,
              groups: selectedGroup
            }
          },
        }));
        // console.log(response);
        setActionToaster({
          error: response?.error,
          msg: `Changes are successfully saved to Order ${selectedRecord.orderno}`,
        });
        showToaster();

        const ordersResponse = refresh();
        // console.log(ordersResponse);
        // const groups=orderSummaryTable.state.data.groups; 
        // const selectedGroup=groups.map((group) => group.id === location.state.groupId ? {...group, priority_orders: group.priority_orders+ (record.priority?-1:1)} : group);

        // setOrderSummaryTable((prevState) => ({
        // ...prevState,
        // state: {
        //   ...prevState.state, 
        //   data: {
        //     ...prevState.state.data,
        //     groups: selectedGroup
        //   }
        // },
        // }));
        setFinalData({ ...finalData, "groups": selectedGroup })
      })
      .catch((error) => {
        console.log("Error in updating order:", error?.response?.data);
        setActionToaster({
          error: error?.response?.data?.error,
          msg: error?.response?.data?.msg,
        });
        showToaster();
      })
      .finally(() => {
        setIsLoading(false);
        toggleEditMode();
        setEditPlannedQty();
        setErrorMessage("");
        setSelectedRecord();
        setIsEditQtyPlanned(false);
        setTableContent([...dataSourceCopy]);
        setTableRerender(true);
      });

  };

  const onPlannedReelActionChange = (index, action, data) => {
    if (action == "remove") {
      form.setFieldsValue({
        [`rewinderreels${data.orderno}`]: data.rewinderreels,
      });
      // let dataSourceCopy = tableData;
      // let record = dataSourceCopy[index];
      // record.rewinderreels = data.rewinderreels;
      // dataSourceCopy[index] = record;
      // setTableData([...dataSourceCopy]);
    } else {
      let enteredReels = form.getFieldValue(`rewinderreels${data.orderno}`);
      calculatePlannedWeightByChangedPlannedReel(
        index,
        data,
        data.plannedQuant,
        data.reelod,
        data.coreid,
        parseFloat(enteredReels)
      );
    }
    if (!isReelEditClicked.hasOwnProperty(data?.orderno)) {
      isReelEditClicked[data?.orderno] = {};
    }
    isReelEditClicked[data?.orderno].isEditable = false;
    setReelIsEditClicked(isReelEditClicked);
    setTableRerender(true);
  };

  const onPlannedReelChange = (e, record, index) => {
    let inputValue;

    inputValue =
      e.target.value !== "" ? parseFloat(e.target.value) : e.target.value;
    const hasError = isNaN(inputValue) || inputValue === 0 || inputValue === "";
    const orderno = record?.orderno;
    if ((plannedReelErr[orderno]?.error || false) !== hasError) {
      const tempPlannedReelErr = { ...plannedReelErr };
      tempPlannedReelErr[orderno] = { error: hasError };
      setPlannedReelErr(tempPlannedReelErr);
      setTableRerender(true);
    }
  };

  const plannedWeightCalculation = (
    index,
    data,
    orderQuantity,
    reelOd,
    coreOd,
    calculatedReels
  ) => {
    let size;
    if (data.type === "Reel") {
      size = data?.width;
    } else {
      size =
        data?.grain === "Long" ||
          data?.grain === "long" ||
          data?.grain === "long grain"
          ? parseFloat(data?.width) > parseFloat(data?.length)
            ? data?.length
            : data?.width
          : parseFloat(data?.length) > parseFloat(data?.width)
            ? data?.length
            : data?.width;
    }

    if (size && coreOd && reelOd && reelOd?.length == 1) {
      let reelConversionValue =
        orderDim_Rewinder_Unit_Conversion[reelOd[0]?.split(" ")[1]];
      let coreConversionValue =
        orderDim_Rewinder_Unit_Conversion[coreOd?.split(" ")[1]];
      let conversionValue =
        orderDim_Rewinder_Unit_Conversion[data?.units?.width];
      return calculatePlannedWeight(
        data,
        size * conversionValue,
        data?.product_info?.bulk,
        reelOd[0]?.split(" ")[0] * reelConversionValue,
        coreOd.split(" ")[0] * coreConversionValue,
        calculatedReels
      );
    } else {
      if (data.type === "Reel") {
        return 0;
      } else {
        if (data.type == "Sheet" && data.quantity_type === "weight") {
          if (orderQuantity) {
            return orderQuantity;
          } else {
            return 0;
          }
        } else {
          let weightUnit = data?.units?.planned_weight;

          let dimensionUnit = data?.units?.width;
          let conversionValue =
            orderDim_Rewinder_Unit_Conversion[dimensionUnit];

          let length_Value = data.length * conversionValue;
          let width_Value = data.width * conversionValue;

          const value =
            (length_Value *
              width_Value *
              orderQuantity *
              data?.product_info?.gsm) /
            (10000 * 1000000);
          let plannedWeightValue =
            value * conversionFactorTonneToUnits[weightUnit];
          let plannedWt = plannedWeightValue
            ? plannedWeightValue.toFixed(3)
            : 0;
          return plannedWt;
        }
      }
    }
  };

  const handleReelEditColumn = (index, record, value) => {
    setSelectedRecord(record);
    if (!isReelEditClicked.hasOwnProperty(record?.orderno)) {
      isReelEditClicked[record?.orderno] = {};
    }
    form.setFieldsValue({ [`rewinderreels${record?.orderno}`]: record.rewinderreels })
    isReelEditClicked[record?.orderno].isEditable = true;
    setReelIsEditClicked(isReelEditClicked);
    setTableRerender(true);
  };

  const getAllOrders = () => {
    let selectedOrdersTotalWeight = 0,
      selectedOrderUnit,
      plannedWeightTempArray = [];
    let updatedTableContect = ordersList.map((order) => {
      let filteredGroup = finalData.groups.filter(
        (group) => group.id == location?.state?.groupId
      );
      // Calculate quantityValue based on your conditions
      let quantityValue;
      let rewinderReels;

      if (order.type === "reel" && order.quantity_type === "reel_sheet") {
        quantityValue =
          order.this_item_type === "order"
            ? Math.round(order.quantity) + " " + "Reels"
            : Math.round(order.no_of_reel_sheet) + " " + "Reels";
        rewinderReels =
          order.this_item_type == "order"
            ? Math.round(order.quantity)
            : Math.round(order.total_quantity);
      } else if (
        order.type === "sheet" &&
        order.quantity_type === "reel_sheet"
      ) {
        quantityValue =
          order.weight?.toFixed(3) +
          " " +
          capitalize(weightUnit[order.units.planned_weight]?.displayName);
        quantityValue += "\n" + Math.round(order.no_of_sheets) + " " + "Sheets";
        rewinderReels =
          order.this_item_type == "order"
            ? Math.round(order.quantity)
            : Math.round(order.total_quantity);
      } else if (
        (order.type === "reel" || order.type === "sheet") &&
        order.quantity_type === "weight"
      ) {
        quantityValue =
          order.weight +
          " " +
          capitalize(weightUnit[order.units.weight]?.displayName);
        rewinderReels =
          order.this_item_type == "order"
            ? Math.round(order.quantity)
            : Math.round(order.total_quantity);
      }

      // Calculate processQuantity based on your conditions
      let processQuantity;
      if (order.type === "reel" && order.quantity_type === "reel_sheet") {
        processQuantity = order.total_processed_quantity.quantity + " Reels";
      } else if (
        order.type === "sheet" &&
        order.quantity_type === "reel_sheet"
      ) {
        processQuantity =
          order.total_processed_quantity.weight +
          " " +
          capitalize(
            weightUnit[order.total_processed_quantity.units.weight]?.displayName
          ) +
          "\n" +
          Math.round(order.total_processed_quantity.quantity) +
          " " +
          "Sheets";
      } else
        processQuantity =
          order.total_processed_quantity.weight +
          " " +
          capitalize(
            weightUnit[order.total_processed_quantity.units.weight]?.displayName
          );

      // Calculate plannedQuant based on your requirements
      let plannedQuant;
      if (
        (order.type === "reel" || order.type === "sheet") &&
        order.quantity_type === "reel_sheet"
      ) {
        plannedQuant =
          order.planning_quantity.toFixed(3) +
          " " +
          capitalize(order.type) +
          "s";
      } else
        plannedQuant =
          order.planning_weight.toFixed(3) +
          " " +
          capitalize(
            order.units?.planned_weight
              ? weightUnit[order.units?.planned_weight]?.displayName
              : "T"
          );
      let reelod = "";
      if (order.id_od_type === "constant") {
        // Join all the values of outer_dia with their units and separate them with commas
        reelod = order.outer_dia.map((dia) => `${dia}`).join(", ");
      } else if (order.id_od_type === "range") {
        reelod = `${order.minimum_reel_od} ${order.units?.minimum_reel_od}- ${order.maximum_reel_od} ${order.units?.maximum_reel_od}`;
      }

      // Calculate coreid based on inner_dia and units
      let coreid = `${order.inner_dia}`;
      let temp = {
        order: order.id,
        planned_weight: order.planned_weight,
        units: order.units
      };
      plannedWeightTempArray.push(temp);
      if (
        !finalData.groups.filter((group) =>
          group.unselected_orders.includes(order.number)
        ).length > 0
      ) {
        selectedOrderUnit = capitalize(
          weightUnit[order.units.planned_weight]?.displayName
        );
        selectedOrdersTotalWeight += parseFloat(order.planned_weight);
      }
      let pendingQuant;
      if (order.type === "reel" && order.quantity_type === "reel_sheet") {
        pendingQuant = order.total_pending_quantity.quantity + " Reels";
      } else if (
        order.type === "sheet" &&
        order.quantity_type === "reel_sheet"
      ) {
        pendingQuant =
          order.total_pending_quantity.weight +
          " " +
          capitalize(
            weightUnit[order.total_pending_quantity.units.weight]?.displayName
          ) +
          "\n" +
          Math.round(order.total_pending_quantity.quantity) +
          " " +
          "Sheets";
      } else
        pendingQuant =
          order.total_pending_quantity.weight +
          " " +
          capitalize(
            weightUnit[order.total_pending_quantity.units.weight]?.displayName
          );
      const width = order.width?.toFixed(3);
      const length = order.length?.toFixed(3);
      const widthDisplay = Number.isInteger(order.width) ? order.width : width;
      const lengthDisplay = Number.isInteger(order.length)
        ? order.length
        : length;
      const size = `${widthDisplay}${order.length ? `x${lengthDisplay}` : ""
        } ${lengthUnit[order.units.width]?.displayName?.toUpperCase()}`;

      // console.log(order);
      let currencySymbol;
      if (order?.units?.net_price) {
        currencySymbol = currency_List.filter(
          (currUnit) => currUnit.code === order.units.net_price
        );
      } else {
        currencySymbol = "";
      }
      let currencySymbolDealer;
      if (order?.units?.dealer_price) {
        currencySymbolDealer = currency_List.filter(
          (currUnit) => currUnit.code === order.units.dealer_price
        );
      } else {
        currencySymbolDealer = "";
      }

      const balance_qty = (order.balance_weight == 0) ? "-" : order.balance_weight + " " + capitalize(order.units.weight);
      let jobID = []
      if (order?.jobcards?.jobcards) {
        order?.jobcards?.jobcards.map((item, index) => {
          jobID.push(item.jobcard)
        })
      }
      return {
        checked:
          !orderIdList?.includes(order.number)
            ? false
            : true,
        key: `${order.uuid}`,
        jobcards: order.jobID,
        isConflictingstate: order.conflicting_state === "non_conflicting" ? false : true,
        pono: `${order.po}`,
        sono: `${order.so}`,
        category: `${order.category}`,
        groupno: `${order.split_group ? order.split_group : "-"}`,
        orderno: `${order.number}`,
        createddate: moment(order.created_at).format("DD MMM YYYY"),
        podate: moment(
          order.category === "po" ? order.po_date : order.so_date
        ).format("DD MMM YYYY"),
        productcode: `${order.product}`,
        productspec: `${order.product_spec}`,
        customercode: `${order.customer}`,
        type: capitalize(order.type),
        size: size,
        plannedQuantity: `${filteredGroup[0].pending_quantities[order.number] +
          " " +
          (filteredGroup[0].core_id && filteredGroup[0].reel_od
            ? "Reel"
            : capitalize(order.type))
          }s`,
        plannedWeight: order.planned_weight
          ? `${order.planned_weight.toFixed(
            3
          )} ${capitalize(
            weightUnit[order.units.planned_weight]?.displayName
          )}`
          : "-",
        pendingWeight: order.pending_quantity_weight
          ? `${order.pending_quantity_weight.toFixed(3)} ${capitalize(
            weightUnit[order.units.planned_weight]?.displayName
          )}`
          : "-",
        coreid: coreid !== "" ? coreid : "0 cm",
        reelod: reelod !== "" ? order.outer_dia : ["0 cm"],
        reelodd: reelod !== "" ? reelod : ["0 cm"],
        inner_dia: order.inner_dia,
        outer_dia: order.outer_dia,
        item_type: order.item_type,
        deliverydate:
          order.category === "so"
            ? "-"
            : moment(order.delivery_date).format("DD MMM YYYY"),
        quantity: `${order.quantity} ${capitalize(order.type)}s`,
        // Weight unit: Default 'Tonnes'
        weight: `${order.weight} ${order.units.weight
            ? capitalize(weightUnit[order.units.weight]?.displayName)
            : ""
          }`,
        rewinderreels: rewinderReels ? rewinderReels : "0",

        priority: order.forced,
        remarks: order.remarks,
        completed: order.completed,
        in_progress: order.in_process,
        in_production: order.in_production + order.in_process,
        // Deckle matching pending = quantity - (completed + in_progress)
        pending: order.quantity - order.completed - order.in_process,
        customer_name: `${order.customer_name}`,
        customer_alias: `${order.customer_alias}`,
        consignee_name: `${order.consignee_name}`,
        consignee_alias: `${order.consignee_alias}`,
        consignee: order.consignee,
        sheet_completed_weight: order.sheet_completed_weight
          ? order.sheet_completed_weight
          : 0,
        sheet_processed_weight: order.sheet_processed_weight
          ? order.sheet_processed_weight
          : 0,
        sheet_production_weight: order.sheet_production_weight
          ? order.sheet_production_weight
          : 0,
        pending_quantity_weight: order.pending_quantity_weight,
        units: order.units,
        // quantityValue = order.this_item_type == "i"
        quantityValue: quantityValue,
        processQuantity: processQuantity,
        plannedQuant: plannedQuant,
        pendingQuant: pendingQuant,
        calculated_lower_tolerance: order.calculated_lower_tolerance.toFixed(3),
        calculated_upper_tolerance: order.calculated_upper_tolerance.toFixed(3),
        od_type: order.id_od_type,
        id_od_type: order.id_od_type,
        group_id: order.group,
        quantity_type: order.quantity_type,
        gsm: order.product_info?.gsm,
        bulk: order.product_info?.bulk,
        width: order.width,
        grain: order.grain,
        length: order.length,
        minimum_reel_od: order.minimum_reel_od,
        maximum_reel_od: order.maximum_reel_od,
        progressbar_info: order.progressbar_info,
        order_type: order.type,
        // quantity_type: order.quantity_type,
        isReel: order?.type === "reel",
        matchedGrain: order.grain,
        id: order.id,
        product_info: order.product_info,
        price: order.dealer_price ? order.dealer_price : 0,
        netprice:
          order.net_price &&
            order.quantity_type == "reel_sheet" &&
            order.type == "reel"
            ? ""
            : order.net_price
              ? `${order.units && currencySymbol ? currencySymbol[0].symbol : ""
              }` +
              " " +
              parseFloat(order.net_price).toFixed(3)
              : "",
        dealerPrice: order.dealer_price
          ? `${order.units && currencySymbolDealer
            ? currencySymbolDealer[0].symbol
            : ""
          }` +
          " " +
          parseFloat(order.dealer_price).toFixed(3) +
          " " +
          `${order?.units?.per_weight_unit
            ? " / " +
            capitalize(weightUnit[
              order.units.per_weight_unit
            ]?.displayName)
            : ""
          }`
          : "-",
        dealer_price: order.dealer_price,
        balance_qty: balance_qty,

      };
    });
    selectedOrdersTotalWeight = parseFloat(
      selectedOrdersTotalWeight.toFixed(3)
    );
    const totalWeightWithUnit =
      selectedOrdersTotalWeight.toString() + " " + selectedOrderUnit;
    if (ordersList.length)
      setPendingWeightsArray(plannedWeightTempArray);

    let sortedTableContent;
    if (action == 'view') {
      sortedTableContent = [
        ...updatedTableContect.filter((item) => item.checked === true)]
    }
    else {
      sortedTableContent = [
        ...updatedTableContect.filter((item) => item.checked === true),
        ...updatedTableContect.filter((item) => item.checked === false),
      ];
    }
    return sortedTableContent;
  };

  const showEditReelCoreModal = (record, type, index, orderType) => {
    setSelectedRecord(record);
    setSelectedType(type);
    setSelectedIndex(index);
    setEditReelCoreModal(true);
  };
  // const getData = () => {
  //   const data = ordersList.map((order) => {
  //     const productSpec = productsList.filter(
  //       (product) => product.code === order.product
  //     );
  //     const posSpec = posList.filter((pos) => pos.number === order.po);

  //     return {
  //       customercode: `${posSpec[0]?.customer}`,
  //       productspec: `${productSpec[0]?.grade}/${productSpec[0]?.gsm}/${
  //         productSpec[0]?.burst_factor
  //       }${productSpec[0]?.quality ? `/${productSpec[0].quality}` : ""}`,
  //     };
  //   });

  //   return data;
  // };

  // console.log("table", tableContent);

  const handleCheckboxChangeFactory =
    (record, columnKey, data, setData, setSelection) => async (event) => {
      // console.log(data);
      if (showAlert.isGlobalReelODChanged) {
        setShowAlert(prev => ({
          ...prev,
          isReelOrderChanged: true
        }));
      }
      let rowIndex = data.findIndex((item) => item.orderno === record.orderno);
      const dataToUpdate = [...data];
      dataToUpdate[rowIndex][columnKey] = event.target.checked;
      let request = {
        key: event.target.checked ? "add" : "remove",
        group: location?.state?.groupId,
        order: +dataToUpdate[rowIndex].orderno,
      };
      const resp = await addOrRemoveOrdersFromGroup(request);
      let updatedFinalData = finalData;
      let isMergedGroupUpdated = false;
      updatedFinalData.groups.forEach((group, index) => {
        if (group.id == resp.data.data.group.id) {
          updatedFinalData.groups[index] = resp.data.data.group;
          updatedFinalData.total_selected_orders = event.target.checked
            ? updatedFinalData.total_selected_orders + 1
            : updatedFinalData.total_selected_orders - 1;
          updatedFinalData.total_production_weight =
            resp.data.data.total_production_weight;
        }
        if (group.merged == true) {
          isMergedGroupUpdated = true;
        }
      });

      let updatedOrderIdList = [];
      if (event.target.checked) {
        updatedOrderIdList = orderIdList.includes(
          dataToUpdate[rowIndex].orderno
        )
          ? orderIdList
          : [...orderIdList, parseInt(dataToUpdate[rowIndex].orderno)];

        setOrderIdList(updatedOrderIdList);
      } else {
        updatedOrderIdList = orderIdList.filter(
          (item) => item !== parseInt(dataToUpdate[rowIndex].orderno)
        );

        setOrderIdList(updatedOrderIdList);
        if (!isReelEditClicked.hasOwnProperty(record?.orderno)) {
          isReelEditClicked[record?.orderno] = {};
        }
        isReelEditClicked[record?.orderno].isEditable = false;
        setReelIsEditClicked(isReelEditClicked);
        setIsEditQtyPlanned(false);
        setEditTolerance(false);
        setTableRerender(true);
      }

      const unselectedOrders = resp.data.data.group.unselected_orders;
      const unit = resp.data.data.units.planned_weights;

      let totalPendingWeight = 0;

      for (const item of pendingWeightsArray) {
        if (!unselectedOrders.includes(item.order)) {
          totalPendingWeight += item.planned_weight;
        }
      }
      // const formattedSelectedQty = `${totalPendingWeight.toFixed(3)} ${unit}`;
      // setSelectedQty(formattedSelectedQty);

      setFinalData(updatedFinalData);
      setOrderSummaryTable((prevState) => ({
        ...prevState,
        state: {
          ...prevState?.state,
          data: updatedFinalData
        },
      }));
      if (isMergedGroupUpdated) {
        setMergeGroupsData(updatedFinalData);
      }
      setData(dataToUpdate);
      setSelection(
        data.filter((item) => item.checked == true).map((item) => item.orderno)
      );
      //const formattedSelectedQty = event.target.checked ? parseFloat(selectedQty) +  (pendingWeightsArray[rowIndex].planned_weight  * conversionFactorUnitsToTonne[pendingWeightsArray[rowIndex].units.planned_weight]) : parseFloat(selectedQty) -  (pendingWeightsArray[rowIndex].planned_weight * conversionFactorUnitsToTonne[pendingWeightsArray[rowIndex].units.planned_weight]);
      const formattedSelectedQty = event.target.checked ? parseFloat(selectedQty) + (parseFloat(record?.plannedWeight) * conversionFactorUnitsToTonne[record?.units?.planned_weight]) : parseFloat(selectedQty) - (parseFloat(record?.plannedWeight) * conversionFactorUnitsToTonne[record?.units?.planned_weight]);
      setSelectedQty(formattedSelectedQty.toFixed(3));

      // console.log('selection', selectedPendingOrders);
      setTableContent([...dataToUpdate])
    };

  const routeBack = () => {
    isBackClick.current = true;
    nextClickRef.current = true;
    isCancelJobCard.current = false;
    let updatedGroups = location?.state?.data?.groups.map((group) => {
      if (group.id === location?.state?.groupId) {
        return {
          ...group,
          weight: parseFloat(selectedQty?.toString().split(" ")[0]),
        };
      }
      return group;
    });

    if (!orderIdList.length) {
      updatedGroups = updatedGroups.filter(data => data.id != groupId);
    }

    const updatedData = {
      ...location?.state?.data,
      groups: updatedGroups,
    };
    history("../order-summary", {
      state: {
        data: finalData,
        selected_type: location?.state?.selected_type,
        selected_rewinder: location.state.selected_rewinder,
        selected_cutter: location.state.selected_cutter,
        selected_rewinder_unit: location.state.selected_rewinder_unit,
        selected_cutter_unit: location.state.selected_cutter_unit,
        rewinder_data: location.state.rewinder_data,
        cutter_data: location.state.cutter_data,
        rewinder_minWidth: location.state.rewinder_minWidth,
        rewinder_maxWidth: location.state.rewinder_maxWidth,
        cutter_minWidth: location.state.cutter_minWidth,
        cutter_maxWidth: location.state.cutter_maxWidth,
        max_NoOfCutters: location.state.max_NoOfCutters,
        minWeight: location.state.minWeight,
        left_edge_trim: location.state.left_edge_trim,
        right_edge_trim: location.state.right_edge_trim,
        code: location.state.code,
        initital_OrderType: location.state.initital_OrderType,
        is_enabled: location.state.is_enabled,
        body: location.state.body,
        machine_code: location.state.machine_code,
        type: location.state.type,
        partitionWeightUnit: location.state.partitionWeightUnit,
        orderResponse: location.state.orderResponse,
        selectedQty: selectedQty,
        newGroupData: finalData,
        selectedRowKeys: location.state.selectedRowKeys,
        totalWeight: location.state.totalWeight,
        max_NoOfCutters_cutter: location.state.max_NoOfCutters_cutter,
        left_edge_trim_cutter: location.state.left_edge_trim_cutter,
        right_edge_trim_cutter: location.state.right_edge_trim_cutter,
        processType: location.state.processType,
        isDummyJC: location.state.isDummyJC,
        so: location.state.so,
        // selectedQty: selectedQty,
        // groupId: location.state?.groupId,
      },
    });
  };

  const getRow = (record, index) => {
    if (index != 0 && ordersList[index]?.po !== ordersList[index - 1]?.po)
      return `highlight-bottom-border ${record.priority && "true"}`;
    else return record.priority && "true";
  }

  const toggleEditMode = () => {
    setEditMode(!editMode);
    if (!editMode) {
      setEditPlannedQty(selectedRecord.plannedQuant);
      // validatePlannedQuantitiy(selectedRecord.plannedQuant, selectedRecord);
    }
    setErrorMessage("");
  };
  const calcSize = (record) => {
    if (record.type === "Reel")
      return (
        record.width * orderDim_Rewinder_Unit_Conversion[record?.units?.width]
      );
    if (record.grain === "short")
      return (
        (record.width > record.length ? record.width : record.length) *
        orderDim_Rewinder_Unit_Conversion[record?.units?.width]
      );
    if (record.grain === "long")
      return (
        (record.width < record.length ? record.width : record.length) *
        orderDim_Rewinder_Unit_Conversion[record?.units?.width]
      );
  };
  const calcPlannedReels = (record, size, reelOD, plannedQty, coreidcm) => {
    if (record.quantity_type === "weight") {
      return parseFloat(
        (parseFloat(plannedQty) * 1000 * 1000 * record.bulk * 4) /
        (3.14 *
          size *
          (parseFloat(reelOD) * parseFloat(reelOD) -
            parseFloat(coreidcm) * parseFloat(coreidcm)))
      );
    }
    if (record.type === "Reel") return parseFloat(plannedQty);

    return (
      (record.length *
        orderDim_Rewinder_Unit_Conversion[record?.units?.width] *
        record.width *
        orderDim_Rewinder_Unit_Conversion[record?.units?.width] *
        parseFloat(plannedQty) *
        record.gsm *
        record.bulk *
        4) /
      (100 *
        100 *
        3.14 *
        size *
        (parseFloat(reelOD) * parseFloat(reelOD) -
          parseFloat(coreidcm) * parseFloat(coreidcm)))
    );
  };
  const calcPlannedWeight = (record, od_type, reelOD, plannedQty, coreidcm) => {
    // const convertedReeOd = reelOd.split(' ')[0] * conversion
    if (od_type === "range") {
      if (record.type === "Sheet" && record.quantity_type === "reel_sheet") {
        return parseFloat(
          parseFloat(
            record.width *
            orderDim_Rewinder_Unit_Conversion[record?.units?.width] *
            parseFloat(plannedQty) *
            record.gsm *
            record.length *
            orderDim_Rewinder_Unit_Conversion[record?.units?.width]
          ) / 10000000000
        );
      }
      return parseFloat(plannedQty);
    }
    const size = parseFloat(calcSize(record));
    let plannedReel = calcPlannedReels(
      record,
      size,
      reelOD,
      plannedQty,
      coreidcm
    );
    if (plannedReel < 1 && plannedReel > 0) plannedReel = 1;
    plannedReel = plannedReel.toFixed(0);
    return (
      (3.14 *
        plannedReel *
        size *
        (parseFloat(reelOD) * parseFloat(reelOD) -
          parseFloat(coreidcm) * parseFloat(coreidcm))) /
      (1000 * 1000 * record.bulk * 4)
    );
  };

  const handleSave = (record, isReelODChanged, reelData) => {
    let quantityKey = 0;
    if (
      (record.reelod && record.reelod.length == 1) ||
      (record.type?.toLowerCase() == "reel" && record.quantity_type == "reel_sheet")
    ) {
      quantityKey = parseFloat(record?.rewinderreels);
    }
    if (isLoading) return;
    setIsLoading(true);
    let odType, reelUnit, reelod;
    let plannedQty = editPlannedQty
      ? editPlannedQty
      : record.plannedQuant.split(" ")[0];
    plannedQty *=
      record.quantity_type === "weight"
        ? conversionFactorUnitsToTonne[record.units.planned_weight]
        : 1;
    if (!isReelODChanged) {
      odType = record.od_type;
      if (record.id_od_type === "range") {
        reelod = {
          minimum_reel_od: record.minimum_reel_od,
          maximum_reel_od: record.maximum_reel_od,
        };
        reelUnit = {
          minimum_reel_od: record?.units?.minimum_reel_od,
          maximum_reel_od: record?.units?.maximum_reel_od,
        };
      } else {
        reelod = record.outer_dia;
      }
    } else {
      odType = reelData.reelODType;
      if (odType === "constant") {
        reelod = reelData.reelOD;
      } else {
        reelod = {
          minimum_reel_od: reelData.minReelOD,
          maximum_reel_od: reelData.maxReelOD,
        };
        reelUnit = reelData.reelODUnit;
      }
    }
    let weight;
    // console.log(odType, record);
    if (
      odType === "constant" &&
      reelod.length === 1 &&
      reelod[0] !== "0 cm" &&
      record.coreid !== "0 cm"
    ) {
      const reelodcm =
        parseFloat(reelod[0].split(" ")[0]) *
        orderDim_Rewinder_Unit_Conversion[reelod[0].split(" ")[1]];
      // console.log(reelodcm);
      const coreidcm =
        parseFloat(record.coreid.split(" ")[0]) *
        orderDim_Rewinder_Unit_Conversion[record.coreid.split(" ")[1]];
      // console.log(
      //   coreidcm,
      //   record.coreid,
      //   record.coreid.split(" ")[0],
      //   orderDim_Rewinder_Unit_Conversion[record.coreid.split(" ")[1]]
      // );
      weight = calcPlannedWeight(
        record,
        odType,
        reelodcm,
        plannedQty,
        coreidcm
      );
    } else if (
      // odType === "range" &&
      record.type === "Sheet" &&
      record.quantity_type === "reel_sheet"
    ) {
      weight = parseFloat(
        parseFloat(
          record.width *
          orderDim_Rewinder_Unit_Conversion[record?.units?.width] *
          parseFloat(plannedQty) *
          record.gsm *
          record.length *
          orderDim_Rewinder_Unit_Conversion[record?.units?.width]
        ) / 10000000000
      );
    } else weight = parseFloat(plannedQty);
    let requestBody;
    if (!isReelODChanged) {
      requestBody = {
        order_id: selectedRecord?.orderno,
        planned_weight:
          weight * conversionFactorTonneToUnits[record.units.planned_weight],
        group_id: location.state.groupId,
        // reel_od: reelod,
        // od_type: odType,
        units: {
          planned_weight: selectedRecord.units?.planned_weight,
          // minimum_reel_od: reelUnit?.minimum_reel_od,
          // maximum_reel_od: reelUnit?.maximum_reel_od,
        },
        planning_quantity: parseFloat(
          plannedQty *
          (record.quantity_type === "weight"
            ? conversionFactorTonneToUnits[record.units.planned_weight]
            : 1)
        ),
        quantity: quantityKey,
      };
    } else {
      requestBody = {
        order_id: selectedRecord?.orderno,
        planned_weight:
          weight * conversionFactorTonneToUnits[record.units.planned_weight],
        group_id: location.state.groupId,
        reel_od: reelod,
        od_type: odType,
        cutter_reel_dia: false,
        quantity: quantityKey,
        units: {
          planned_weight: selectedRecord.units?.planned_weight,
          minimum_reel_od: reelUnit?.minimum_reel_od,
          maximum_reel_od: reelUnit?.maximum_reel_od,
        },
      };
    }
    editQtyToBePlannedForReviewOrder(requestBody)
      .then((response) => {
        if (showAlert.isGlobalReelODChanged) {
          setShowAlert((prev) => ({
            ...prev,
            isReelODChanged: true,
          }))
        }
        setNewGroupData(response.data.group_data);
        const groups = orderSummaryTable.state.data.groups;
        const selectedGroup = groups.map((group) => group.id === location.state.groupId ? response.data.group_data : group);

        setOrderSummaryTable((prevState) => ({
          ...prevState,
          state: {
            ...prevState?.state,
            data: {
              ...prevState?.state?.data,
              groups: selectedGroup
            }
          },
        }));
        // console.log(response);
        setActionToaster({
          error: response?.error,
          msg: `Changes are successfully saved to Order ${selectedRecord.orderno}`,
        });
        showToaster();

        const ordersResponse = refresh();

        setFinalData({ ...finalData, "groups": selectedGroup })
      })
      .catch((error) => {
        console.log("Error in updating order:", error?.response?.data);
        setActionToaster({
          error: error?.response?.data?.error,
          msg: error?.response?.data?.msg,
        });
        showToaster();
      })
      .finally(() => {
        setIsLoading(false);
        toggleEditMode();
        setEditPlannedQty();
        setErrorMessage("");
        setSelectedRecord();
        setIsEditQtyPlanned(false);
      });
  };
  const handleDiscard = () => {
    toggleEditMode();
    setEditPlannedQty();
    setSelectedRecord();
    setIsEditQtyPlanned(false);
  };
  const validatePlannedQuantitiy = (newValue, record) => {
    const validInputPattern = /^(\d*\.)?\d+$/;

    if (validInputPattern.test(newValue)) {
      const floatValue = parseFloat(newValue);
      let pendingQuantValue = parseFloat(record.pendingQuant.split(" ")[0]);
      if (record.type === "Sheet" && record.quantity_type === "reel_sheet") {
        let temp = record.pendingQuant?.split("\n")[1];
        temp = temp?.split("Sheets")[0];
        pendingQuantValue = parseFloat(temp);
      }
      if (floatValue <= 0) {
        setIsSaveButtonVisible(false);
        setErrorMessage("Please enter a positive non-zero number.");
      }
      // else if (floatValue > pendingQuantValue) {
      //   setIsSaveButtonVisible(false);
      //   setErrorMessage("Entered value exceeds the pending quantity.");
      // } 
      else {
        setIsSaveButtonVisible(true);
        setErrorMessage("");
      }
    } else {
      setIsSaveButtonVisible(false);
      setErrorMessage("Invalid input. Please enter a valid number.");
    }
  };
  const handleInputChange = (e) => {
    let newValue = e.target.value.trim();
    setEditPlannedQty(newValue);
    validatePlannedQuantitiy(newValue, selectedRecord);
  };

  const handleEditColumn = (value, record, isEditQty) => {
    setEditMode(value);
    setIsEditQtyPlanned(isEditQty);
    setSelectedRecord(record);
    if (value) {
      // console.log(1);
      setEditPlannedQty(record.plannedQuant.split(" ")[0]);
      validatePlannedQuantitiy(record.plannedQuant.split(" ")[0], record);
      setErrorMessage("");
      // setEditPlannedQty();
    }
    setIsSaveButtonVisible(false);
  };


  const handlePriorityChange = async (record) => {
    try {
      setSelectedRecord(record);
      const body = {
        group: location.state.groupId,
        priority: !record.priority,
        order: record.orderno,
      };

      const response = await changePriorityofGroupOrder(body);
      setActionToaster({
        error: response.error,
        msg: `Changes are successfully saved to Order ${record.orderno}`,
      });
      showToaster();
      const ordersResponse = refresh();
      console.log(ordersResponse);
      const groups = orderSummaryTable.state.data.groups;
      const selectedGroup = groups.map((group) => group.id === location.state.groupId ? { ...group, priority_orders: group.priority_orders + (record.priority ? -1 : 1) } : group);

      setOrderSummaryTable((prevState) => ({
        ...prevState,
        state: {
          ...prevState?.state,
          data: {
            ...prevState?.state?.data,
            groups: selectedGroup
          }
        },
      }));
      setFinalData({ ...finalData, "groups": selectedGroup })
    } catch (error) {
      console.log("Error in updating order:", error?.response?.data);
      setActionToaster({
        error: error?.response?.error,
        msg: error?.response?.msg,
      });
      showToaster();
    }
  };

  const modalConfirm = async () => {
    setDeleteModal(false);
    const deleteResponse = await deleteGroup(groupId);
    isBackClick.current = true;
    nextClickRef.current = true;
    isCancelJobCard.current = false;


    const updatedData = {
      ...location?.state?.data,
      ...deleteResponse.data,
    };

    setOrderSummaryTable((prevState) => ({
      ...prevState,
      state: {
        ...prevState?.state,
        data:
          deleteResponse?.data

      },
    }));

    history("../order-summary", {
      state: {
        data: finalData,
        selected_type: location?.state?.selected_type,
        selected_rewinder: location.state.selected_rewinder,
        selected_cutter: location.state.selected_cutter,
        selected_rewinder_unit: location.state.selected_rewinder_unit,
        selected_cutter_unit: location.state.selected_cutter_unit,
        rewinder_data: location.state.rewinder_data,
        cutter_data: location.state.cutter_data,
        rewinder_minWidth: location.state.rewinder_minWidth,
        rewinder_maxWidth: location.state.rewinder_maxWidth,
        cutter_minWidth: location.state.cutter_minWidth,
        cutter_maxWidth: location.state.cutter_maxWidth,
        max_NoOfCutters: location.state.max_NoOfCutters,
        minWeight: location.state.minWeight,
        left_edge_trim: location.state.left_edge_trim,
        right_edge_trim: location.state.right_edge_trim,
        code: location.state.code,
        initital_OrderType: location.state.initital_OrderType,
        is_enabled: location.state.is_enabled,
        body: location.state.body,
        machine_code: location.state.machine_code,
        type: location.state.type,
        partitionWeightUnit: location.state.partitionWeightUnit,
        orderResponse: location.state.orderResponse,
        selectedQty: selectedQty,
        newGroupData: updatedData,
        selectedRowKeys: location.state.selectedRowKeys,
        totalWeight: location.state.totalWeight,
        max_NoOfCutters_cutter: location.state.max_NoOfCutters_cutter,
        left_edge_trim_cutter: location.state.left_edge_trim_cutter,
        right_edge_trim_cutter: location.state.right_edge_trim_cutter,
        processType: location.state.processType,
        isDummyJC: location.state.isDummyJC,
        so: location.state.so,
        // selectedQty: selectedQty,
        // groupId: location.state?.groupId,
      },
    });
  }

  const onConfirmGroup = () => {
    if (orderIdList.length) {
      if (showAlert.isGlobalReelODChanged && showAlert.isReelOrderChanged || showAlert.isReelODChanged) {
        setViewConfirmGroupModal(true);
      } else {
        routeBack();
      }
    } else {
      setDeleteModal(true);
    }
  };
  const modalCancel = () => {
    setDeleteModal(false);
  }

  const refresh = () => {
    setLoading(true);
    let req = {
      flow_type: machineData.planningType == 'purchaseOrder' ? 'po' : 'quality',
      jobcard_type: machineData.processType == 'multiStage' ? 'multi_stage' : 'single_stage',
      group_id: groupId,
      machine_data: machineData.processType == 'multiStage' && machineData.planningType == 'purchaseOrder' ? machineData.machine_data : machineData,
      filter: appliedFilters,
      fetch_type: selectedState,
      dummy_orders: location.state.isDummyJC ? true : false,
      so_number: location.state.so,
    };
    getOrdersListForCreateNewSol(req, searchValue)
      .then((response) => {
        setOrdersList(response.data);
        let selectedOrderUnit;
        // let isMergedGroupUpdated = false;

        setTotalOrders(response.data.length);
        let totalPendingWeight = 0;

        for (const item of response.data) {
          if (orderIdList.includes(item.number)) {
            totalPendingWeight += item.planned_weight * conversionFactorUnitsToTonne[item.units.planned_weight];
            selectedOrderUnit = capitalize(
              weightUnit[item.units.planned_weight]?.displayName
            );
          }

        }
        const formattedSelectedQty =
          (totalPendingWeight).toFixed(3);
        setSelectedQty(formattedSelectedQty);

        setEmptyStateLabel("noData");

      })
      .catch((error) => {
        console.log("error", error);
        setEmptyStateLabel("connectionAPIError");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const applyfilter = (filter) => {

    let temp = appliedFilters;
    let alreadySetFilter = false;
    for (let i = 0; i < temp.length; i++) {
      if (temp[i].type === filter.type) {
        temp[i] = filter;
        alreadySetFilter = true;
      }
    }
    setCurrentPage(1);
    setPaginationParams((prevState) => ({
      ...prevState,
      page: 1,
      size: settingsData?.settings?.default_page_size || 10,
    }));
    const tempVar = alreadySetFilter ? [...temp] : temp.concat(filter);
    setAppliedFilters(tempVar);
    setLoading(true);
    setFilterTags(tempVar.map(formatFilters));

    //setTableData([]);
  };

  const formatFilters = (item) => {
    switch (item.type) {
      case "customer":
        const value =
          item.names.length > 1
            ? `${item.names[0]} or ${item.names.length - 1} others`
            : `${item.names[0]}`;
        // const concatString = item.names.join(" or ");
        // const customerToolTip = `Country equals ${concatString}`;
        return {
          type: item.type,
          formattedType: "Customer",
          operand: "equals",
          value,
          // tooltip: customerToolTip,
        };
      case "consignee":
        const consigneeValue =
          item.names.length > 1
            ? `${item.names[0]} or ${item.names.length - 1} others`
            : `${item.names[0]}`;
        // const concatString = item.names.join(" or ");
        // const customerToolTip = `Country equals ${concatString}`;
        return {
          type: item.type,
          formattedType: "Consignee",
          operand: "equals",
          value: consigneeValue,
          // tooltip: customerToolTip,
        };
      case "order_type":
        const typeValue =
          item.order_type === "reel"
            ? "Reel"
            : item.order_type === "sheet"
              ? "Sheet"
              : "Reel or Sheet";
        return {
          type: item.type,
          formattedType: "Order Type",
          operand: "equals",
          value: typeValue,
          // tooltip: `Order Type equals ${typeValue}`,
        };
      case "created_date":
        let dateOperand = "";
        let dateValue = "";
        if (item.start_date === item.end_date) {
          dateOperand = "-";
          dateValue = moment(item.start_date).format("DD MMMM YY");
        } else {
          dateOperand = "between";
          dateValue = `${moment(item.start_date).format(
            "DD MMMM YY"
          )} - ${moment(item.end_date).format("DD MMMM YY")}`;
        }
        return {
          type: item.type,
          formattedType: "Created date",
          operand: dateOperand,
          value: dateValue,
        };
      case "po_date":
        let poDateOperand = "";
        let poDateValue = "";
        if (item.start_date === item.end_date) {
          poDateOperand = "-";
          poDateValue = moment(item.start_date).format("DD MMMM YY");
        } else {
          poDateOperand = "between";
          poDateValue = `${moment(item.start_date).format(
            "DD MMMM YY"
          )} - ${moment(item.end_date).format("DD MMMM YY")}`;
        }
        return {
          type: item.type,
          formattedType: "PO date",
          operand: poDateOperand,
          value: poDateValue,
        };
      case "delivery_date":
        let deliveryDateOperand = "";
        let deliveryDateValue = "";
        if (item.start_date === item.end_date) {
          deliveryDateOperand = "-";
          deliveryDateValue = moment(item.start_date).format("DD MMMM YY");
        } else {
          deliveryDateOperand = "between";
          deliveryDateValue = `${moment(item.start_date).format(
            "DD MMMM YY"
          )} - ${moment(item.end_date).format("DD MMMM YY")}`;
        }
        return {
          type: item.type,
          formattedType: "Delivery date",
          operand: deliveryDateOperand,
          value: deliveryDateValue,
        };
      case "gsm":
        const gsmValue =
          item.operator === "in_range"
            ? `${item.min_gsm} and ${item.max_gsm}`
            : `${item.gsm}`;
        const gsmOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
              ? "equals"
              : item.operator === "less_than"
                ? "less than"
                : item.operator === "greater_than"
                  ? "greater than"
                  : "";
        return {
          type: item.type,
          formattedType: "GSM",
          operand: gsmOperand,
          value: gsmValue,
          // tooltip: `GSM ${gsmOperand} ${gsmValue}`,
        };
      case "burst_factor":
        const bfValue =
          item.operator === "in_range"
            ? `${item.min_burst_factor} and ${item.max_burst_factor}`
            : `${item.burst_factor}`;
        const bfOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
              ? "equals"
              : item.operator === "less_than"
                ? "less than"
                : item.operator === "greater_than"
                  ? "greater than"
                  : "";
        return {
          type: item.type,
          formattedType: "Burst factor",
          operand: bfOperand,
          value: bfValue,
          // tooltip: `Burst factor ${bfOperand} ${bfValue}`,
        };
      case "reel_od":
        const reelOdValue =
          item.operator === "in_range"
            ? `${item.min_reel_od} and ${item.max_reel_od}`
            : `${item.reel_od}`;
        const reelOdOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
              ? "equals"
              : item.operator === "less_than"
                ? "less than"
                : item.operator === "greater_than"
                  ? "greater than"
                  : "";
        return {
          type: item.type,
          formattedType: "Reel OD",
          operand: reelOdOperand,
          value: reelOdValue,
          // tooltip: `Reel OD ${reelOdOperand} ${reelOdValue}`,
        };
      case "core_id":
        const coreIdValue =
          item.operator === "in_range"
            ? `${item.min_core_id} and ${item.max_core_id}`
            : `${item.core_id}`;
        const coreIdOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
              ? "equals"
              : item.operator === "less_than"
                ? "less than"
                : item.operator === "greater_than"
                  ? "greater than"
                  : "";
        return {
          type: item.type,
          formattedType: "Core ID",
          operand: coreIdOperand,
          value: coreIdValue,
          // tooltip: `Core ID ${coreIdOperand} ${coreIdValue}`,
        };
      case "grade_quality":
        const gradeValue =
          item.grades.length > 1
            ? `${item.grades[0].grade}(${item.grades[0].qualities.join()}) or ${item.grades.length - 1
            } others`
            : `${item.grades[0].grade}` +
            (item.grades[0].qualities?.length
              ? `"(${item.grades[0].qualities.join()})"`
              : ``);
        return {
          type: item.type,
          formattedType: "Grade",
          operand: "-",
          value: gradeValue,
          // tooltip: `Core ID ${coreIdOperand} ${coreIdValue}`
        };
      case "size":
        const sizeValue =
          item.operator === "in_range"
            ? `${item.min_size} and ${item.max_size}`
            : `${item.size}`;
        const sizetype =
          item.size_type === "width"
            ? "Width"
            : item.size_type === "length"
              ? "Length"
              : "Width / Length";
        const sizeOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
              ? "equals"
              : item.operator === "less_than"
                ? "less than"
                : item.operator === "greater_than"
                  ? "greater than"
                  : "";
        return {
          type: item.type,
          formattedType: sizetype,
          operand: sizeOperand,
          value: sizeValue,
          // tooltip: `${sizetype} ${sizeOperand} ${sizeValue}`,
        };
    }
  };

  const removeFilter = (filter) => {
    columnsHead.current?.map((item) => {
      item["sortOrder"] = null;
    });
    const filterList = appliedFilters.filter((item) => {
      return item.type !== filter.type;
    });
    const formattedFilterList = filterTags.filter((item) => {
      return item.type !== filter.type;
    });
    setFilterTags(formattedFilterList);
    setAppliedFilters(filterList);
    //setSearchValue("");
    //setClearSearch(true);
    setLoading(true);
    //setRendering(true);
  };

  const onDropdownFilterChange = (e) => {
    setSelectedState(e);
    setLoading(true);
    let req = {
      flow_type: machineData.planningType == 'purchaseOrder' ? 'po' : 'quality',
      jobcard_type: machineData.processType == 'multiStage' ? 'multi_stage' : 'single_stage',
      group_id: groupId,
      machine_data: machineData.processType == 'multiStage' && machineData.planningType == 'purchaseOrder' ? machineData.machine_data : machineData,
      filter: appliedFilters,
      fetch_type: e,
      dummy_orders: location.state.isDummyJC,
      so_number: location.state.so,

      //jobcard_id: jobId,
    };
    getOrdersListForCreateNewSol(req, searchValue)
      .then((response) => {
        setOrdersList(response.data);
        setEmptyStateLabel("noData");
      })
      .catch((error) => {
        console.log("error", error);
        setEmptyStateLabel("connectionAPIError");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const searchOrders = async (value = "") => {
    setSearchValue(value);
    setCurrentPage(1);
    setPaginationParams((prevState) => ({
      ...prevState,
      page: 1,
      size: settingsData?.settings?.default_page_size || 10,
    }));
    setLoading(true);
    let req = {
      flow_type: machineData.planningType == 'purchaseOrder' ? 'po' : 'quality',
      jobcard_type: machineData.processType == 'multiStage' ? 'multi_stage' : 'single_stage',
      group_id: groupId,
      machine_data: machineData.processType == 'multiStage' && machineData.planningType == 'purchaseOrder' ? machineData.machine_data : machineData,
      filter: appliedFilters,
      fetch_type: selectedState,
      dummy_orders: location.state.isDummyJC,
      so_number: location.state.so,
      //jobcard_id: jobId,
    };
    getOrdersListForCreateNewSol(req, value)
      .then((response) => {
        setOrdersList(response.data);
        setEmptyStateLabel("search");
      })
      .catch((error) => {
        console.log("error", error);
        setEmptyStateLabel("connectionAPIError");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onEditClick = () => {
    setCurrentPage(1);
    setPaginationParams({
      page: 1,
      size: settingsData?.settings?.default_page_size || 10,
      sort_by: "updated_at",
      sort_type: "ascending",
    });
    setAction('edit');
    refresh();
  }

  const onChange = async (pagination, filters, sorter, extra) => {
    //setLoading(true);

    setCurrentPage(pagination.current);
    setPaginationParams({
      page: pagination.current,
      size: pagination.pageSize,
    });

    // console.log(sorter);
  };
  const validateTolerance = () => {
    setErrorMessage("");
    setIsSaveButtonVisible(true);
    lowerBoundRef.current.input.style.borderColor = "#d9d9d9ff";
    upperBoundRef.current.input.style.borderColor = "#d9d9d9ff";
    const validInputPattern = /^(\d*\.)?\d+$/;
    if (lowerTolerance == "" || upperTolerance == "") {
      setErrorMessage("This field is required");
      setIsSaveButtonVisible(false);
      if (lowerTolerance == "") {
        lowerBoundRef.current.input.style.borderColor = "red";
      }
      if (upperTolerance == "") {
        upperBoundRef.current.input.style.borderColor = "red";
      }
    } else if (
      !validInputPattern.test(lowerTolerance) ||
      !validInputPattern.test(upperTolerance)
    ) {
      setErrorMessage("This field should be a non-zero positive value");
      setIsSaveButtonVisible(false);
      if (!validInputPattern.test(lowerTolerance))
        lowerBoundRef.current.input.style.borderColor = "red";
      if (!validInputPattern.test(upperTolerance))
        upperBoundRef.current.input.style.borderColor = "red";
    }
    else if (parseFloat(lowerTolerance) > parseFloat(selectedRecord.plannedWeight)) {
      setErrorMessage("Lower bound should be less than or equal to Planned Weight");
      setIsSaveButtonVisible(false);
      lowerBoundRef.current.input.style.borderColor = "red";
    }
    else if (parseFloat(upperTolerance) < parseFloat(selectedRecord.plannedWeight)) {
      setErrorMessage("Upper bound should be greater than or equal to Planned Weight");
      setIsSaveButtonVisible(false);
      upperBoundRef.current.input.style.borderColor = "red";
    }
  };

  // const columnsHead = [
  //   {
  //     title: "Select",
  //     dataIndex: "checked",
  //     width: "3%",
  //     fixed: "left",
  //     align: "left",
  //     render: (value, record, rowIndex) => (
  //       <div className="actionBtn">
  //         <Styled>
  //           <Tooltip
  //             placement="topRight"
  //             title={
  //               record?.priority ? "Priority orders cannot be deselected" : ""
  //             }
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Checkbox
  //               checked={value}
  //               onChange={handleCheckboxChangeFactory(
  //                 record,
  //                 "checked",
  //                 tableContent,
  //                 setTableContent,
  //                 setSelectedOrders
  //               )}
  //               disabled={action === "view"}
  //             />
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "Po/So.No",
  //     dataIndex: "pono",
  //     width: "3%",
  //     fixed: "left",
  //     align: "left",

  //     render: (text, record) => (
  //       <span
  //         style={{
  //           whiteSpace: "normal",
  //           wordBreak: "break-word",
  //           lineHeight: "1.4",
  //         }}
  //       >
  //         {`${
  //           record.category === "so"
  //             ? toHandlePOName(record.sono)
  //             : toHandlePOName(record.pono)
  //         }`
  //           .match(/.{1,15}/g)
  //           ?.map((chunk, index) => (
  //             <span key={index}>
  //               {chunk}
  //               <br />
  //             </span>
  //           ))}
  //       </span>
  //     ),
  //   },
  //   // {
  //   //   title: "Group No.",
  //   //   dataIndex: "groupno",
  //   //   width: "3%",
  //   //   fixed: "left",
  //   //   align:'left',
  //   // },
  //   {
  //     title: "Order No",
  //     dataIndex: "orderno",
  //     width: "2%",
  //     fixed: "left",
  //     align: "left",
  //   },
  //   {
  //     title: "PO Date",
  //     dataIndex: "podate",
  //     width: "3%",
  //     align: "left",
  //   },
  //   {
  //     title: "Customer",
  //     dataIndex: "customer_alias",
  //     width: "3%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         {record.category === "so" ? (
  //           "-"
  //         ) : (
  //           <Styled>
  //             <Tooltip
  //               placement="bottomRight"
  //               title={`${record.customercode}-${record.customer_name}`}
  //               className="edit-tooltip"
  //               getPopupContainer={(triggerNode) => triggerNode}
  //             >
  //               {record?.customer_alias || "-"}
  //             </Tooltip>
  //           </Styled>
  //         )}
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "Consignee",
  //     dataIndex: "consignee_alias",
  //     width: "3%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         {record.category === "so" ? (
  //           "-"
  //         ) : (
  //           <Styled>
  //             <Tooltip
  //               placement="bottomRight"
  //               title={`${record.consignee}-${record.consignee_name}`}
  //               className="edit-tooltip"
  //               getPopupContainer={(triggerNode) => triggerNode}
  //             >
  //               {record?.consignee_alias || "-"}
  //             </Tooltip>
  //           </Styled>
  //         )}
  //       </div>
  //     ),
  //   },
  //   {
  //     title: (
  //       <div>
  //         Product Spec
  //         <Styled style={{ display: "inline-flex" }}>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={
  //               "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
  //             }
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <span className="infoIcon"></span>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     dataIndex: "productspec",
  //     width: "4.5%",
  //   },
  //   // {
  //   //   title: "Type",
  //   //   dataIndex: "type",
  //   //   width: "2%",
  //   // },
  //   {
  //     title: "Size(WxL)",
  //     dataIndex: "size",
  //     width: "2.5%",
  //     align: "left",
  //   },
  //   {
  //     title: "Grain",
  //     dataIndex: "grain",
  //     width: "4%",
  //     render: (text, record, index) => (
  //       <Styled>
  //         {record.order_type.toLowerCase() === "sheet" ? (
  //           <div style={{ display: "flex" }}>
  //             <Row className="centerAlign">
  //               <div className="boxFormType">
  //                 <Form form={form}>
  //                   <SelectStyle>
  //                     <Form.Item
  //                       name={`grain${record.id}`}
  //                       rules={[
  //                         {
  //                           required: true,
  //                           message: "This field is required",
  //                         },
  //                       ]}
  //                       className="selectForm"
  //                       style={{ marginBottom: 4 }}
  //                       initialValue={record.grain ? record.grain : null}
  //                     >
  //                       <Select
  //                         placeholder={"Select"}
  //                         suffixIcon={<DownArrowDraw />}
  //                         onChange={(e) => onGrainChange(e, record, index)}
  //                         disabled={action == "view" || !record.checked}
  //                       >
  //                         {grainTypeData.map((grainType) => (
  //                           <Option key={grainType.value}>
  //                             {grainType.label}
  //                           </Option>
  //                         ))}
  //                       </Select>
  //                     </Form.Item>
  //                   </SelectStyle>
  //                 </Form>
  //               </div>
  //             </Row>
  //           </div>
  //         ) : (
  //           ""
  //         )}
  //       </Styled>
  //     ),
  //   },
  //   {
  //     title: "Order Qty",
  //     dataIndex: "quantityValue",
  //     width: "3.4%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div>
  //         {record.quantityValue && record.quantityValue.includes("\n")
  //           ? record.quantityValue.split("\n").map((line, index) => (
  //               <div
  //                 key={index}
  //                 style={{ fontSize: index === 0 ? "smaller" : "default" }}
  //               >
  //                 {line}
  //               </div>
  //             ))
  //           : record.quantityValue}
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "Balance Quantity",
  //     dataIndex: "balance_qty",
  //     width: "7.4%",
  //   },
  //   {
  //     title: "Processed Qty",
  //     dataIndex: "processQuantity",
  //     width: "2.5%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div>
  //         {record.processQuantity && record.processQuantity.includes("\n")
  //           ? record.processQuantity.split("\n").map((line, index) => (
  //               <div
  //                 key={index}
  //                 style={{ fontSize: index === 0 ? "smaller" : "default" }}
  //               >
  //                 {line}
  //               </div>
  //             ))
  //           : record.processQuantity}
  //       </div>
  //     ),
  //   },

  //   // {
  //   //   title: "Pending Qty",
  //   //   dataIndex: "pendingQuant",
  //   //   width: "2.4%",
  //   // },
  //   // {
  //   //   title: "Planned Quantity",
  //   //   dataIndex: "plannedQuantity",
  //   //   width: "2.5%",
  //   // },
  //   // {
  //   //   title: "Planned Weight",
  //   //   dataIndex: "plannedWeight",
  //   //   width: "2.5%",
  //   // },
  //   {
  //     title: "Pending Quantity",
  //     dataIndex: "pendingQuant",
  //     width: "3.4%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div>
  //         {record.pendingQuant && record.pendingQuant.includes("\n")
  //           ? record.pendingQuant.split("\n").map((line, index) => (
  //               <div
  //                 key={index}
  //                 style={{ fontSize: index === 0 ? "smaller" : "default" }}
  //               >
  //                 {line}
  //               </div>
  //             ))
  //           : record.pendingQuant}
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "Qty to be planned",
  //     // dataIndex: "plannedQuant",
  //     width: "5%",
  //     align: "left",
  //     render: (index, record) => (
  //       <span>
  //         {/* {console.log(record)} */}
  //         {editMode &&
  //         record === selectedRecord &&
  //         isEditQtyPlanned &&
  //         editColumn == "Qty to be planned" ? (
  //           <span>
  //             <Input
  //               type="text"
  //               value={editPlannedQty}
  //               onChange={handleInputChange}
  //               style={{
  //                 width: "50%",
  //                 border: "1px solid #d9d9d9ff",
  //                 borderRadius: "5px",
  //                 padding: "7px 3px",
  //                 textalign: "left",
  //                 marginRight: "5px",
  //               }}
  //               // placeholder={record.plannedQuant.split(" ")[1]}
  //             />
  //             {/* <span
  //               style={{
  //                 display: "inline-flex",
  //                 transform: "translateX(-23px)",
  //               }}
  //             >
  //               {record.plannedQuant.split(" ")[1]}
  //             </span> */}
  //             {isSaveButtonVisible && (
  //               <>
  //                 <Tooltip
  //                   placement="bottomRight"
  //                   title={"Save the entered value"}
  //                 >
  //                   <Button
  //                     key="1"
  //                     className="edit-btn"
  //                     style={{
  //                       padding: "0px",
  //                       margin: "0px",
  //                       width: "28px",
  //                       border: "none",
  //                       display: "inline-block",
  //                       marginRight: "10px",
  //                       backgroundColor: "transparent",
  //                     }}
  //                     onClick={() => handleSave(record)}
  //                   >
  //                     <Iconmoon icon="check" size={18} color="#3FBD61" />
  //                   </Button>
  //                 </Tooltip>
  //               </>
  //             )}
  //             <Tooltip
  //               placement="bottomLeft"
  //               title={"Remove the entered value"}
  //             >
  //               <Button
  //                 key="2"
  //                 className="edit-btn"
  //                 style={{
  //                   padding: "0px",
  //                   margin: "0px",
  //                   width: "28px",
  //                   border: "none",
  //                   display: "inline-block",
  //                   backgroundColor: "transparent",
  //                 }}
  //                 onClick={handleDiscard}
  //               >
  //                 <Iconmoon icon="cancel" size={18} color="red" />
  //               </Button>
  //             </Tooltip>
  //             {errorMessage && editColumn == "Qty to be planned" && (
  //               <span
  //                 style={{ color: "red", fontSize: "11px", display: "block" }}
  //               >
  //                 {errorMessage}
  //               </span>
  //             )}
  //           </span>
  //         ) : (
  //           <>
  //             {" "}
  //             <span
  //               style={{
  //                 display: "inline",
  //                 float: "left",
  //                 transform: "translateY(8px)",
  //               }}
  //             >
  //               {record.plannedQuant}
  //             </span>
  //             {record?.checked && action == "edit" && (
  //               <span
  //                 style={{
  //                   display: "inline",
  //                   float: "right",
  //                 }}
  //               >
  //                 <Tooltip
  //                   placement="bottomRight"
  //                   title={"Edit planned quantity"}
  //                   className="edit-tooltip"
  //                   getPopupContainer={(triggerNode) => triggerNode}
  //                 >
  //                   <Button
  //                     onClick={() => {
  //                       handleEditColumn(true, record, true);
  //                       setEditColumn("Qty to be planned");
  //                     }}
  //                     style={{ border: "none", backgroundColor: "transparent" }}
  //                   >
  //                     <Iconmoon icon="edit" size={14} color="#A19F9D" />
  //                   </Button>
  //                 </Tooltip>
  //               </span>
  //             )}
  //           </>
  //         )}
  //       </span>
  //     ),
  //   },
  //   {
  //     title: "Tolerance Level",
  //     dataIndex: "tolerancelevel",
  //     width: "6%",
  //     render: (text, record) => (
  //       <>
  //         {editTolerance &&
  //         record == selectedRecord &&
  //         editColumn == "Tolerance Level" ? (
  //           <span
  //             style={{
  //               display: "flex",
  //               alignItems: "center",
  //             }}
  //           >
  //             <span
  //               style={{
  //                 display: "flex",
  //                 flexDirection: "column",
  //               }}
  //             >
  //               <span>
  //                 LB
  //                 <Input
  //                   type="text"
  //                   ref={lowerBoundRef}
  //                   value={lowerTolerance}
  //                   onChange={(e) => setLowerTolerance(e.target.value)}
  //                   style={{
  //                     width: "50%",
  //                     border: "1.5px solid #d9d9d9ff",
  //                     borderRadius: "5px",
  //                     padding: "7px 3px",
  //                     textalign: "left",
  //                     margin: "5px",
  //                   }}
  //                 />
  //               </span>

  //               <span>
  //                 UB
  //                 <Input
  //                   type="text"
  //                   ref={upperBoundRef}
  //                   value={upperTolerance}
  //                   onChange={(e) => setUpperTolerance(e.target.value)}
  //                   style={{
  //                     width: "50%",
  //                     border: "1.5px solid #d9d9d9ff",
  //                     borderRadius: "5px",
  //                     padding: "7px 3px",
  //                     textalign: "left",
  //                     margin: "5px",
  //                   }}
  //                 />
  //               </span>
  //             </span>
  //             <span
  //               style={{
  //                 height: "100%",
  //                 display: "flex",
  //                 alignItems: "center",
  //               }}
  //             >
  //               {isSaveButtonVisible && (
  //                 <>
  //                   <Tooltip
  //                     placement="bottomRight"
  //                     title={"Save the entered value"}
  //                   >
  //                     <Button
  //                       key="1"
  //                       className="edit-btn"
  //                       style={{
  //                         padding: "0px",
  //                         margin: "0px",
  //                         width: "28px",
  //                         border: "none",
  //                         display: "inline-block",
  //                         marginRight: "10px",
  //                         backgroundColor: "transparent",
  //                       }}
  //                       onClick={handleSaveTolerance}
  //                     >
  //                       <Iconmoon icon="check" size={18} color="#3FBD61" />
  //                     </Button>
  //                   </Tooltip>
  //                 </>
  //               )}
  //               <Tooltip
  //                 placement="bottomLeft"
  //                 title={"Remove the entered value"}
  //               >
  //                 <Button
  //                   key="2"
  //                   className="edit-btn"
  //                   style={{
  //                     padding: "0px",
  //                     margin: "0px",
  //                     width: "28px",
  //                     border: "none",
  //                     display: "inline-block",
  //                     backgroundColor: "transparent",
  //                   }}
  //                   onClick={handleDiscardTolerance}
  //                 >
  //                   <Iconmoon icon="cancel" size={18} color="red" />
  //                 </Button>
  //               </Tooltip>
  //             </span>
  //           </span>
  //         ) : (
  //           <span
  //             style={{
  //               display: "flex",
  //               justifyContent: "space-between",
  //               alignItems: "center",
  //             }}
  //           >
  //             <span>
  //               LB <strong>{record.calculated_lower_tolerance}</strong> UB{" "}
  //               <strong>{record.calculated_upper_tolerance}</strong>
  //             </span>
  //             {action == "edit" && record?.checked && (
  //               <Tooltip
  //                 placement="bottomRight"
  //                 title={"Edit Order Tolerance"}
  //                 className="edit-tooltip"
  //                 getPopupContainer={(triggerNode) => triggerNode}
  //               >
  //                 <Button
  //                   onClick={() => {
  //                     setEditTolerance(true);
  //                     setSelectedRecord(record);
  //                     setEditColumn("Tolerance Level");
  //                   }}
  //                   style={{ border: "none", backgroundColor: "transparent" }}
  //                 >
  //                   <Iconmoon icon="edit" size={14} color="#A19F9D" />
  //                 </Button>
  //               </Tooltip>
  //             )}
  //           </span>
  //         )}
  //         {errorMessage &&
  //           record == selectedRecord &&
  //           editColumn == "Tolerance Level" && (
  //             <span
  //               style={{ color: "red", fontSize: "11px", display: "block" }}
  //             >
  //               {errorMessage}
  //             </span>
  //           )}
  //       </>
  //     ),
  //   },
  //   {
  //     title: "Reel OD",
  //     dataIndex: "reelod",
  //     width: "3%",
  //     align: "left",
  //     render: (text, record, index) => (
  //       <Styled>
  //         {/* {console.log(record)} */}
  //         <div style={{ display: "flex" }}>
  //           {record.id_od_type == "range" && (
  //             <div
  //               style={{
  //                 color: "var(--para-text)",
  //                 display: "flex",
  //                 width: "70%",
  //                 alignSelf: "center",
  //               }}
  //             >
  //               {record.minimum_reel_od +
  //                 " " +
  //                 lengthUnit[record.units.minimum_reel_od]?.displayName +
  //                 " -" +
  //                 record.maximum_reel_od +
  //                 " " +
  //                 lengthUnit[record.units.maximum_reel_od]?.displayName}
  //             </div>
  //           )}
  //           {record.id_od_type == "constant" && (
  //             <div
  //               style={{
  //                 display: "flex",
  //                 width: "70%",
  //                 flexDirection: "column",
  //                 alignSelf: "center",
  //               }}
  //             >
  //               {record?.reelod &&
  //                 record?.reelod?.map((item, index) => {
  //                   return (
  //                     index < 2 && (
  //                       <div>
  //                         {item}{" "}
  //                         {index == 1
  //                           ? "...,"
  //                           : record?.reelod?.length > 1
  //                           ? ","
  //                           : ""}
  //                       </div>
  //                     )
  //                   );
  //                 })}

  //               {record?.reelod &&
  //                 record?.reelod?.length >= 2 &&
  //                 record?.reelod?.map((item, index) => {
  //                   let tooltipData = "";
  //                   for (
  //                     let index = 2;
  //                     index < record.reelod?.length;
  //                     index++
  //                   ) {
  //                     const data = record.reelod[index];
  //                     tooltipData = tooltipData + data + ", ";
  //                   }
  //                   tooltipData = tooltipData.substring(
  //                     0,
  //                     tooltipData.length - 1
  //                   );
  //                   return (
  //                     index == 2 && (
  //                       <Tooltip title={tooltipData}>
  //                         {" "}
  //                         <span
  //                           style={{
  //                             display: "flex",
  //                             fontSize: "10px",
  //                             fontWeight: "bold",
  //                           }}
  //                         >
  //                           & {record?.reelod?.length - 2} More
  //                         </span>
  //                       </Tooltip>
  //                     )
  //                   );
  //                 })}
  //             </div>
  //           )}
  //           <div style={{ display: "flex", width: "30%" }}>
  //             <div className="actionBtn">
  //               {" "}
  //               {userDetails?.roles?.job_cards.edit &&
  //                 record?.checked &&
  //                 action == "edit" && (
  //                   <Button
  //                     onClick={() =>
  //                       showEditReelCoreModal(
  //                         record,
  //                         "reel",
  //                         index,
  //                         "complete_order"
  //                       )
  //                     }
  //                     style={{ background: "none" }}
  //                   >
  //                     <Iconmoon
  //                       icon="down"
  //                       size={30}
  //                       color="var(--para-text)"
  //                     />
  //                   </Button>
  //                 )}{" "}
  //             </div>
  //           </div>
  //         </div>
  //       </Styled>
  //     ),
  //   },
  //   {
  //     title: "Core ID",
  //     dataIndex: "coreid",
  //     width: "2%",
  //     align: "left",
  //   },

  //   {
  //     title: "Delivery Date",
  //     dataIndex: "deliverydate",
  //     width: "3%",
  //     align: "left",
  //   },

  //   {
  //     title: "Priority",
  //     dataIndex: "priority",
  //     width: "2.2%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         <Button
  //           style={{ cursor: "default" }}
  //           onClick={() => {
  //             handlePriorityChange(record);
  //           }}
  //           disabled={action == "view" || !record.checked}
  //         >
  //           <Iconmoon
  //             icon={record?.priority ? "correct" : "wrong"}
  //             size={16}
  //             color={record?.priority ? "#3FBD61" : "#a19f9d"}
  //           />
  //         </Button>
  //       </div>
  //     ),
  //     align: "left",
  //   },
  //   {
  //     title: "Remarks",
  //     dataIndex: "remarks",
  //     width: "2.2%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={record?.remarks}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button style={{ cursor: "default" }}>
  //               <Iconmoon icon="message" size={16} color="#EA655B" />
  //             </Button>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     align: "left",
  //   },
  //   // {
  //   //   title: "Progress",
  //   //   dataIndex: "progress",
  //   //   width: "2.5%",
  //   //   render: (text, record) => (
  //   //     <div className="progressLvl">
  //   //       <Styled>
  //   //         <Tooltip
  //   //           placement="bottomRight"
  //   //           title={`${record.completed} Reels produced
  //   //                     ${record.in_progress} Reels in production
  //   //                     ${record.pendingQuantity} pending for deckle match`}
  //   //           className="edit-tooltip"
  //   //           getPopupContainer={(triggerNode) => triggerNode}
  //   //         >
  //   //           <Progress
  //   //             percent={
  //   //               ((record.completed + record.in_production) /
  //   //                 parseFloat(record.quantity.split(" ")[0])) *
  //   //               100
  //   //             }
  //   //             success={{
  //   //               percent:
  //   //                 (record.completed /
  //   //                   parseFloat(record.quantity.split(" ")[0])) *
  //   //                 100,
  //   //             }}
  //   //             strokeColor={{
  //   //               "75%": "#cbe2cd",
  //   //               "100%": "#edebe9",
  //   //             }}
  //   //           />
  //   //         </Tooltip>
  //   //       </Styled>
  //   //     </div>
  //   //   ),
  //   //   align:'left',
  //   // },
  //   {
  //     title: "Actions",
  //     dataIndex: "action",
  //     width: "2.2%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={"View details of this order"}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button
  //               onClick={() => {
  //                 handleActions(record);
  //               }}
  //             >
  //               <Iconmoon icon="file-view" size={16} color="#A19F9D" />
  //             </Button>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     align: "left",
  //   },
  // ];

  // const columnsHeadForSheets = [
  //   {
  //     title: "Select",
  //     dataIndex: "checked",
  //     width: "2%",
  //     fixed: "left",
  //     align: "left",
  //     render: (value, record, rowIndex) => (
  //       <div className="actionBtn">
  //         <Styled>
  //           <Tooltip
  //             placement="topRight"
  //             title={
  //               record?.priority ? "Priority orders cannot be deselected" : ""
  //             }
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Checkbox
  //               checked={value}
  //               onChange={handleCheckboxChangeFactory(
  //                 record,
  //                 "checked",
  //                 tableContent,
  //                 setTableContent,
  //                 setSelectedOrders
  //               )}
  //               disabled={record?.priority ? true : false}
  //             />
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "Po/So.No",
  //     dataIndex: "pono",
  //     width: "3%",
  //     fixed: "left",
  //     align: "left",
  //     render: (text, record) => (
  //       <span
  //         style={{
  //           whiteSpace: "normal",
  //           wordBreak: "break-word",
  //           lineHeight: "1.4",
  //         }}
  //       >
  //         {`${
  //           record.category === "so"
  //             ? toHandlePOName(record.sono)
  //             : toHandlePOName(record.pono)
  //         }`
  //           .match(/.{1,15}/g)
  //           ?.map((chunk, index) => (
  //             <span key={index}>
  //               {chunk}
  //               <br />
  //             </span>
  //           ))}
  //       </span>
  //     ),
  //   },
  //   {
  //     title: "Group No.",
  //     dataIndex: "groupno",
  //     width: "3%",
  //     fixed: "left",
  //     align: "left",
  //   },
  //   {
  //     title: "Order No",
  //     dataIndex: "orderno",
  //     width: "2%",
  //     fixed: "left",
  //   },
  //   {
  //     title: "PO Date",
  //     dataIndex: "podate",
  //     width: "3%",
  //     align: "left",
  //   },
  //   {
  //     title: "Customer",
  //     dataIndex: "customer_alias",
  //     width: "3%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         {record.category === "so" ? (
  //           "-"
  //         ) : (
  //           <Styled>
  //             <Tooltip
  //               placement="bottomRight"
  //               title={`${record.customercode}-${record.customer_name}`}
  //               className="edit-tooltip"
  //               getPopupContainer={(triggerNode) => triggerNode}
  //             >
  //               {record?.customer_alias || "-"}
  //             </Tooltip>
  //           </Styled>
  //         )}
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "Consignee",
  //     dataIndex: "consignee_alias",
  //     width: "3%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         {record.category === "so" ? (
  //           "-"
  //         ) : (
  //           <Styled>
  //             <Tooltip
  //               placement="bottomRight"
  //               title={`${record.consignee}-${record.consignee_name}`}
  //               className="edit-tooltip"
  //               getPopupContainer={(triggerNode) => triggerNode}
  //             >
  //               {record?.consignee_alias || "-"}
  //             </Tooltip>
  //           </Styled>
  //         )}
  //       </div>
  //     ),
  //   },
  //   {
  //     title: (
  //       <div>
  //         Product Spec
  //         <Styled style={{ display: "inline-flex" }}>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={
  //               "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
  //             }
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <span className="infoIcon"></span>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     dataIndex: "productspec",
  //     width: "4.5%",
  //   },
  //   {
  //     title: "Type",
  //     dataIndex: "type",
  //     width: "2%",
  //   },
  //   {
  //     title: "Size(WxL)",
  //     dataIndex: "size",
  //     width: "2.5%",
  //   },
  //   {
  //     title: "Order Qty",
  //     dataIndex: "quantityValue",
  //     width: "3.4%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div>
  //         {record.quantityValue && record.quantityValue.includes("\n")
  //           ? record.quantityValue.split("\n").map((line, index) => (
  //               <div
  //                 key={index}
  //                 style={{ fontSize: index === 0 ? "smaller" : "default" }}
  //               >
  //                 {line}
  //               </div>
  //             ))
  //           : record.quantityValue}
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "Balance Quantity",
  //     dataIndex: "balance_qty",
  //     width: "7.4%",
  //   },
  //   // {
  //   //   title: "Planned Quantity",
  //   //   dataIndex: "plannedQuantity",
  //   //   width: "2.5%",
  //   // },
  //   // {
  //   //   title: "Planned Weight",
  //   //   dataIndex: "plannedWeight",
  //   //   width: "2.5%",
  //   // },

  //   // {
  //   //   title: "Pending Quantity",
  //   //   dataIndex: "plannedQuantity",
  //   //   width: "2.6%",
  //   // },
  //   // {
  //   //   title: "Pending Weight",
  //   //   dataIndex: "pendingWeight",
  //   //   width: "2.6%",
  //   // },

  //   {
  //     title: "Pending Quantity",
  //     dataIndex: "pendingQuant",
  //     width: "3.4%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div>
  //         {record.pendingQuant && record.pendingQuant.includes("\n")
  //           ? record.pendingQuant.split("\n").map((line, index) => (
  //               <div
  //                 key={index}
  //                 style={{ fontSize: index === 0 ? "smaller" : "default" }}
  //               >
  //                 {line}
  //               </div>
  //             ))
  //           : record.pendingQuant}
  //       </div>
  //     ),
  //   },

  //   // {
  //   //   title: "Reel OD",
  //   //   dataIndex: "reelod",
  //   //   width: "2%",
  //   // },
  //   {
  //     title: "Delivery Date",
  //     dataIndex: "deliverydate",
  //     width: "3%",
  //   },
  //   {
  //     title: "Remarks",
  //     dataIndex: "remarks",
  //     width: "2%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={record?.remarks}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button style={{ cursor: "default" }}>
  //               <Iconmoon icon="message" size={16} color="#EA655B" />
  //             </Button>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     align: "left",
  //   },
  //   {
  //     title: "Priority",
  //     dataIndex: "priority",
  //     width: "1.9%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         <Button style={{ cursor: "default" }}>
  //           <Iconmoon
  //             icon={record?.priority ? "correct" : "wrong"}
  //             size={16}
  //             color={record?.priority ? "#3FBD61" : "#a19f9d"}
  //           />
  //         </Button>
  //       </div>
  //     ),
  //     align: "left",
  //   },
  //   {
  //     title: "Progress",
  //     dataIndex: "progress",
  //     width: "4%",
  //     render: (text, record) => {
  //       // console.log(record.order_type, record.type);
  //       // if(record.item_type && record.item_type === "order"){
  //       if (
  //         record?.order_type === "sheet" ||
  //         (record?.order_type === "reel" && record?.quantity_type === "weight")
  //       ) {
  //         const totalProd =
  //           ((record?.progressbar_info?.completed?.weight +
  //             record?.progressbar_info?.in_production?.weight) /
  //             (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
  //           100;
  //         const totalCompleted =
  //           (record?.progressbar_info?.completed?.weight /
  //             (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
  //           100;
  //         //const weightUnitKey =  ((record?.units && record?.units?.weight) ? capitalize(weightUnit[record.units.weight]?.displayName) : "T") ;
  //         return (
  //           <div className="progressLvl">
  //             <Styled>
  //               <Tooltip
  //                 placement="bottomRight"
  //                 title={`${
  //                   record?.progressbar_info?.completed
  //                     ? (record?.progressbar_info?.completed?.weight).toFixed(3)
  //                     : 0.0
  //                 } ${capitalize(
  //                   weightUnit[
  //                     record?.progressbar_info?.completed?.units?.weight
  //                   ].displayName
  //                 )} Weight produced
  //                         ${
  //                           record?.progressbar_info?.in_production
  //                             ? (record?.progressbar_info?.in_production?.weight).toFixed(
  //                                 3
  //                               )
  //                             : 0.0
  //                         } ${capitalize(
  //                   weightUnit[
  //                     record?.progressbar_info?.in_production?.units?.weight
  //                   ].displayName
  //                 )} Weight in production
  //                       ${
  //                         record?.progressbar_info?.pending
  //                           ? (record?.progressbar_info?.pending?.weight).toFixed(
  //                               3
  //                             )
  //                           : 0.0
  //                       } ${capitalize(
  //                   weightUnit[record?.progressbar_info?.pending?.units?.weight]
  //                     .displayName
  //                 )} Weight pending for deckle match`}
  //                 className="edit-tooltip"
  //                 getPopupContainer={(triggerNode) => triggerNode}
  //               >
  //                 <Progress
  //                   percent={totalProd}
  //                   success={{
  //                     percent: totalCompleted,
  //                   }}
  //                   strokeColor={"#cbe2cd"}
  //                 />
  //               </Tooltip>
  //             </Styled>
  //           </div>
  //         );
  //       } else {
  //         const production =
  //           ((record?.progressbar_info?.completed?.quantity +
  //             record?.progressbar_info?.in_production?.quantity) /
  //             (record?.no_of_reel_sheet -
  //               record.cancelled_quantity?.quantity)) *
  //           100;
  //         const completed =
  //           (record?.progressbar_info?.completed?.quantity /
  //             (record?.no_of_reel_sheet -
  //               record.cancelled_quantity?.quantity)) *
  //           100;

  //         return (
  //           <div className="progressLvl">
  //             <Styled>
  //               <Tooltip
  //                 placement="bottomRight"
  //                 title={`${
  //                   record?.progressbar_info?.completed
  //                     ? record?.progressbar_info?.completed?.quantity
  //                     : 0
  //                 } Reels produced
  //                         ${
  //                           record?.progressbar_info?.in_production
  //                             ? record?.progressbar_info?.in_production
  //                                 ?.quantity
  //                             : 0
  //                         } Reels in production
  //                         ${
  //                           record?.progressbar_info?.pending
  //                             ? record?.progressbar_info?.pending?.quantity
  //                             : 0
  //                         } Reels pending for deckle match`}
  //                 className="edit-tooltip"
  //                 getPopupContainer={(triggerNode) => triggerNode}
  //               >
  //                 <Progress
  //                   percent={production}
  //                   success={{
  //                     percent: completed,
  //                   }}
  //                   strokeColor={"#cbe2cd"}
  //                 />
  //               </Tooltip>
  //             </Styled>
  //           </div>
  //         );
  //       }
  //     },
  //     align: "center",
  //   },
  //   {
  //     title: "Actions",
  //     dataIndex: "action",
  //     width: "1.9%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={"View details of this order"}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button
  //               onClick={() => {
  //                 handleActions(record);
  //               }}
  //             >
  //               <Iconmoon icon="file-view" size={16} color="#A19F9D" />
  //             </Button>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     align: "left",
  //   },
  // ];

  const fullColumnsHead = [
    {
      title: "Select",
      dataIndex: "checked",
      width: "2.5%",
      fixed: "left",
      align: "left",
      render: (value, record, rowIndex) => (
        <div className="actionBtn">
          {record.isConflictingstate ? (
            <span style={{ paddingBottom: '4px', paddingLeft: "5px" }}> <Tooltip title={`Conflicting order, part of ${record.jobcards?.length} conflicting job cards`} placement="top" >
              <Iconmoon icon="info_new" size={16} color="#EA655B" />
            </Tooltip>
            </span>
          ) : (
            // Invisible placeholder to maintain layout
            <span style={{ width: "14px" }}></span>
          )}
          <Styled>
            <Tooltip
              placement="topRight"
              title={
                record?.priority ? "Priority orders cannot be deselected" : ""
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Checkbox
                checked={value}
                onChange={handleCheckboxChangeFactory(
                  record,
                  "checked",
                  tableContent,
                  setTableContent,
                  setSelectedOrders
                )}
                disabled={action === "view" || record.isConflictingstate}
              />
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    {
      title: "Po/So.No",
      dataIndex: "pono",
      width: "3%",
      fixed: "left",
      align: "left",

      render: (text, record) => (
        <span
          style={{
            whiteSpace: "normal",
            wordBreak: "break-word",
            lineHeight: "1.4",
          }}
        >
          {`${record.category === "so"
              ? toHandlePOName(record.sono)
              : toHandlePOName(record.pono)
            }`
            .match(/.{1,15}/g)
            ?.map((chunk, index) => (
              <span key={index}>
                {chunk}
                <br />
              </span>
            ))}
        </span>
      ),
    },
    // {
    //   title: "Group No.",
    //   dataIndex: "groupno",
    //   width: "3%",
    //   fixed: "left",
    //   align:'left',
    // },
    {
      title: "Order No",
      dataIndex: "orderno",
      width: "3%",
      fixed: "left",
      align: "left",
    },
    {
      title: "PO Date",
      dataIndex: "podate",
      width: "3%",
      align: "left",
    },
    {
      title: "Customer",
      dataIndex: "customer_alias",
      width: "3%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          {record.category === "so" ? (
            "-"
          ) : (
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={`${record.customercode}-${record.customer_name}`}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                {record?.customer_alias || "-"}
              </Tooltip>
            </Styled>
          )}
        </div>
      ),
    },
    {
      title: "Consignee",
      dataIndex: "consignee_alias",
      width: "3%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          {record.category === "so" ? (
            "-"
          ) : (
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={`${record.consignee}-${record.consignee_name}`}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                {record?.consignee_alias || "-"}
              </Tooltip>
            </Styled>
          )}
        </div>
      ),
    },
    {
      title: (
        <div>
          Product Spec
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={
                `The product specification is in the ${format}`
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      dataIndex: "productspec",
      width: "4.5%",
    },
    // {
    //   title: "Type",
    //   dataIndex: "type",
    //   width: "2%",
    // },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "2.5%",
      align: "left",
    },
    {
      title: "Grain",
      dataIndex: "grain",
      width: "4%",
      render: (text, record, index) => (
        <Styled>
          {record.order_type.toLowerCase() === "sheet" ? (
            <div style={{ display: "flex" }}>
              <Row className="centerAlign">
                <div className="boxFormType">
                  <Form form={form}>
                    <SelectStyle>
                      <Form.Item
                        name={`grain${record.id}`}
                        rules={[
                          {
                            required: true,
                            message: "This field is required",
                          },
                        ]}
                        className="selectForm"
                        style={{ marginBottom: 4 }}
                        initialValue={record.grain ? record.grain : null}
                      >
                        <Select
                          placeholder={"Select"}
                          suffixIcon={<DownArrowDraw />}
                          onChange={(e) => onGrainChange(e, record, index)}
                          disabled={action == "view" || !record.checked}
                        >
                          {grainTypeData.map((grainType) => (
                            <Option key={grainType.value}>
                              {grainType.label}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </SelectStyle>
                  </Form>
                </div>
              </Row>
            </div>
          ) : (
            ""
          )}
        </Styled>
      ),
    },
    {
      title: "Order Quantity",
      dataIndex: "quantityValue",
      width: "3.4%",
      align: "left",
      render: (text, record) => (
        <div>
          {record.quantityValue && record.quantityValue.includes("\n")
            ? record.quantityValue.split("\n").map((line, index) => (
              <div
                key={index}
                style={{ fontSize: index === 0 ? "smaller" : "default" }}
              >
                {line}
              </div>
            ))
            : record.quantityValue}
        </div>
      ),
    },
    {
      title: "Balance Quantity",
      dataIndex: "balance_qty",
      width: "4%",
    },
    {
      title: "Processed Qty",
      dataIndex: "processQuantity",
      width: "4%",
      align: "left",
      render: (text, record) => (
        <div>
          {record.processQuantity && record.processQuantity.includes("\n")
            ? record.processQuantity.split("\n").map((line, index) => (
              <div
                key={index}
                style={{ fontSize: index === 0 ? "smaller" : "default" }}
              >
                {line}
              </div>
            ))
            : record.processQuantity}
        </div>
      ),
    },

    // {
    //   title: "Pending Qty",
    //   dataIndex: "pendingQuant",
    //   width: "2.4%",
    // },
    // {
    //   title: "Planned Quantity",
    //   dataIndex: "plannedQuantity",
    //   width: "2.5%",
    // },
    // {
    //   title: "Planned Weight",
    //   dataIndex: "plannedWeight",
    //   width: "2.5%",
    // },
    {
      title: "Pending Quantity",
      dataIndex: "pendingQuant",
      width: "4%",
      align: "left",
      render: (text, record) => (
        record.isConflictingstate ? "ND" :
          <div>
            {record.pendingQuant && record.pendingQuant.includes("\n")
              ? record.pendingQuant.split("\n").map((line, index) => (
                <div
                  key={index}
                  style={{ fontSize: index === 0 ? "smaller" : "default" }}
                >
                  {line}
                </div>
              ))
              : record.pendingQuant}
          </div>
      ),
    },
    {
      title: "Qty to be planned",
      dataIndex: "plannedQuant",
      width: "6%",
      align: "left",
      render: (index, record) => (
        <span
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between"
          }}
        >
          {/* {console.log(record)} */}
          {editMode &&
            record === selectedRecord &&
            isEditQtyPlanned &&
            editColumn == "Qty to be planned" ? (
            <span>
              <Input
                type="text"
                value={editPlannedQty}
                onChange={handleInputChange}
                style={{
                  width: "50%",
                  border: "1px solid #d9d9d9ff",
                  borderRadius: "5px",
                  padding: "7px 3px",
                  textalign: "left",
                  marginRight: "5px",
                }}
              // placeholder={record.plannedQuant.split(" ")[1]}
              />
              {/* <span
                style={{
                  display: "inline-flex",
                  transform: "translateX(-23px)",
                }}
              >
                {record.plannedQuant.split(" ")[1]}
              </span> */}
              {isSaveButtonVisible && (
                <>
                  <Tooltip
                    placement="bottomRight"
                    title={"Save the entered value"}
                  >
                    <Button
                      key="1"
                      className="edit-btn"
                      style={{
                        padding: "0px",
                        margin: "0px",
                        width: "28px",
                        border: "none",
                        display: "inline-block",
                        marginRight: "10px",
                        backgroundColor: "transparent",
                      }}
                      onClick={() => handleSave(record)}
                    >
                      <Iconmoon icon="check" size={18} color="#3FBD61" />
                    </Button>
                  </Tooltip>
                </>
              )}
              <Tooltip
                placement="bottomLeft"
                title={"Remove the entered value"}
              >
                <Button
                  key="2"
                  className="edit-btn"
                  style={{
                    padding: "0px",
                    margin: "0px",
                    width: "28px",
                    border: "none",
                    display: "inline-block",
                    backgroundColor: "transparent",
                  }}
                  onClick={handleDiscard}
                >
                  <Iconmoon icon="cancel" size={18} color="red" />
                </Button>
              </Tooltip>
              {errorMessage && editColumn == "Qty to be planned" && (
                <span
                  style={{ color: "red", fontSize: "11px", display: "block" }}
                >
                  {errorMessage}
                </span>
              )}
            </span>
          ) : (
            <>
              {" "}
              <span
                style={{
                  display: "inline",
                  float: "left",
                  // transform: "translateY(8px)",
                }}
              >
                {record.plannedQuant}
              </span>
              {record?.checked && action == "edit" && (
                <span
                  style={{
                    display: "inline",
                    float: "right",
                  }}
                >
                  <Tooltip
                    placement="bottomRight"
                    title={"Edit planned quantity"}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Button
                      onClick={() => {
                        setErrorMessage("")
                        handleEditColumn(true, record, true);
                        setEditColumn("Qty to be planned");
                      }}
                      style={{ border: "none", backgroundColor: "transparent" }}
                    >
                      <Iconmoon icon="edit" size={14} color="#A19F9D" />
                    </Button>
                  </Tooltip>
                </span>
              )}
            </>
          )}
        </span>
      ),
    },
    {
      title: "Tolerance Level",
      dataIndex: "tolerancelevel",
      width: "9%",
      render: (text, record) => (
        <>
          {editTolerance &&
            record == selectedRecord &&
            editColumn == "Tolerance Level" ? (
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between"
              }}
            >
              <span
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <span>
                  LB
                  <Input
                    type="text"
                    ref={lowerBoundRef}
                    value={lowerTolerance}
                    onChange={(e) => setLowerTolerance(e.target.value)}
                    style={{
                      width: "50%",
                      border: "1.5px solid #d9d9d9ff",
                      borderRadius: "5px",
                      padding: "7px 3px",
                      textalign: "left",
                      margin: "5px",
                    }}
                  />
                </span>

                <span>
                  UB
                  <Input
                    type="text"
                    ref={upperBoundRef}
                    value={upperTolerance}
                    onChange={(e) => setUpperTolerance(e.target.value)}
                    style={{
                      width: "50%",
                      border: "1.5px solid #d9d9d9ff",
                      borderRadius: "5px",
                      padding: "7px 3px",
                      textalign: "left",
                      margin: "4px",
                    }}
                  />
                </span>
              </span>
              <span
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <>
                  <Tooltip
                    placement="bottomRight"
                    title={"Save the entered value"}
                  >
                    <Button
                      key="1"
                      className="edit-btn"
                      style={{
                        padding: "0px",
                        margin: "0px",
                        width: "28px",
                        border: "none",
                        display: "inline-block",
                        marginRight: "10px",
                        backgroundColor: "transparent",
                        visibility: isSaveButtonVisible ? "visible" : "hidden"
                      }}
                      onClick={handleSaveTolerance}
                    >
                      <Iconmoon icon="check" size={18} color="#3FBD61" />
                    </Button>
                  </Tooltip>
                </>
                <Tooltip
                  placement="bottomLeft"
                  title={"Remove the entered value"}
                >
                  <Button
                    key="2"
                    className="edit-btn"
                    style={{
                      padding: "0px",
                      margin: "0px",
                      width: "28px",
                      border: "none",
                      display: "inline-block",
                      backgroundColor: "transparent",
                    }}
                    onClick={handleDiscardTolerance}
                  >
                    <Iconmoon icon="cancel" size={18} color="red" />
                  </Button>
                </Tooltip>
              </span>
            </span>
          ) : (
            <span
              style={{
                display: "flex",
                justifyContent: "start",
                alignItems: "center",
              }}
            >
              <span>
                LB <strong>{record.calculated_lower_tolerance + capitalize(record?.units?.calculated_lower_tolerance)}</strong> UB{" "}
                <strong>{record.calculated_upper_tolerance + capitalize(record?.units?.calculated_upper_tolerance)}</strong>
              </span>
              {action == "edit" && record?.checked && (
                <Tooltip
                  placement="bottomRight"
                  title={"Edit Order Tolerance"}
                  className="edit-tooltip"
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  <Button
                    onClick={() => {
                      setErrorMessage("")
                      setLowerTolerance(record.calculated_lower_tolerance);
                      setUpperTolerance(record.calculated_upper_tolerance);
                      setEditTolerance(true);
                      setSelectedRecord(record);
                      setEditColumn("Tolerance Level");
                    }}
                    style={{ border: "none", backgroundColor: "transparent" }}
                  >
                    <Iconmoon icon="edit" size={14} color="#A19F9D" />
                  </Button>
                </Tooltip>
              )}
            </span>
          )}
          {errorMessage &&
            record == selectedRecord &&
            editColumn == "Tolerance Level" && (
              <span
                style={{ color: "red", fontSize: "11px", display: "block" }}
              >
                {errorMessage}
              </span>
            )}
        </>
      ),
    },
    {
      title: (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <span>Reel OD</span>
          <span className="actionBtn">
            {userDetails?.roles?.job_cards.edit && action == "edit" && (
              <Tooltip
                placement="topRight"
                title={"Edit Job Card Reel OD"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button
                  onClick={() => {
                    setIsJobCardReelODEditModalVisible(true);
                  }}
                  style={{ border: "none", backgroundColor: "transparent" }}
                >
                  <Iconmoon icon="edit" size={14} color="#A19F9D" />
                </Button>
              </Tooltip>
            )}
          </span>
        </div>
      ), dataIndex: "reelod",
      width: "3%",
      align: "left",
      render: (text, record, index) => (
        <Styled>
          {/* {console.log(record)} */}
          <div style={{ display: "flex" }}>
            {record.id_od_type == "range" && (
              <div
                style={{
                  color: "var(--para-text)",
                  display: "flex",
                  width: "70%",
                  alignSelf: "center",
                }}
              >
                {record.minimum_reel_od +
                  " " +
                  lengthUnit[record.units.minimum_reel_od]?.displayName +
                  " -" +
                  record.maximum_reel_od +
                  " " +
                  lengthUnit[record.units.maximum_reel_od]?.displayName}
              </div>
            )}
            {record.id_od_type == "constant" && (
              <div
                style={{
                  display: "flex",
                  width: "70%",
                  flexDirection: "column",
                  alignSelf: "center",
                }}
              >
                {record?.reelod &&
                  record?.reelod?.map((item, index) => {
                    return (
                      index < 2 && (
                        <div>
                          {item}{" "}
                          {index == 1
                            ? "...,"
                            : record?.reelod?.length > 1
                              ? ","
                              : ""}
                        </div>
                      )
                    );
                  })}

                {record?.reelod &&
                  record?.reelod?.length >= 2 &&
                  record?.reelod?.map((item, index) => {
                    let tooltipData = "";
                    for (
                      let index = 2;
                      index < record.reelod?.length;
                      index++
                    ) {
                      const data = record.reelod[index];
                      tooltipData = tooltipData + data + ", ";
                    }
                    tooltipData = tooltipData.substring(
                      0,
                      tooltipData.length - 1
                    );
                    return (
                      index == 2 && (
                        <Tooltip title={tooltipData}>
                          {" "}
                          <span
                            style={{
                              display: "flex",
                              fontSize: "10px",
                              fontWeight: "bold",
                            }}
                          >
                            & {record?.reelod?.length - 2} More
                          </span>
                        </Tooltip>
                      )
                    );
                  })}
              </div>
            )}
            <div style={{ display: "flex", width: "30%" }}>
              <div className="actionBtn">
                {" "}
                {userDetails?.roles?.job_cards.edit &&
                  record?.checked &&
                  action == "edit" && (
                    <Button
                      onClick={() =>
                        showEditReelCoreModal(
                          record,
                          "reel",
                          index,
                          "complete_order"
                        )
                      }
                      style={{ background: "none" }}
                    >
                      <Iconmoon
                        icon="down"
                        size={30}
                        color="var(--para-text)"
                      />
                    </Button>
                  )}{" "}
              </div>
            </div>
          </div>
        </Styled>
      ),
    },
    {
      title: "Core OD",
      dataIndex: "coreid",
      width: "3%",
      align: "left",
    },
    {
      title: "Planned Reels",
      dataIndex: "rewinderreels",
      width: "6%",
      render: (text, record, index) => (
        <div
          className="actionBtn"
          style={{
            marginTop:
              isReelEditClicked?.[record.orderno] &&
                isReelEditClicked?.[record.orderno].isEditable
                ? "10px"
                : "5px",
            justifyContent: "left",
          }}
        >
          {(!isReelEditClicked?.[record.orderno] ||
            (isReelEditClicked?.[record.orderno] &&
              !isReelEditClicked?.[record.orderno].isEditable)) && (
              <Col span={12}>
                {" "}
                {record.rewinderreels != 0
                  ? record.rewinderreels + " Reels"
                  : "-"}
              </Col>
            )}
          {(!isReelEditClicked?.[record.orderno] ||
            (isReelEditClicked?.[record.orderno] &&
              !isReelEditClicked?.[record.orderno].isEditable &&
              userDetails?.roles?.job_cards.edit)) &&
            record.reelod?.length === 1 &&
            record.coreid &&
            record.coreid !== "" &&
            record.coreid !== "-" &&
            record.id_od_type != "range" &&
            ((record.type.toLowerCase() == "reel" &&
              record.quantity_type == "weight") ||
              record.type.toLowerCase() == "sheet") && action != "view" && record?.checked && (
              <Col span={12}>
                <Styled style={{ marginTop: "-7px" }}>
                  <Tooltip
                    placement="bottomRight"
                    title={"Edit planned quantity"}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Button
                      onClick={() => {
                        handleReelEditColumn(index, record, true);
                      }}
                    >
                      <Iconmoon icon="edit" size={16} color="#A19F9D" />
                    </Button>
                  </Tooltip>
                </Styled>
              </Col>
            )}
          {isReelEditClicked?.[record.orderno] &&
            isReelEditClicked?.[record.orderno].isEditable && (
              <DetailFields style={{ paddingBottom: "0px" }}>
                <Styled>
                  <HaberForm>
                    {/* <Form
                      id="form"
                      form={form}
                      name="basic"
                      autoComplete="off"
                      className="qtyToBePlannedInput"
                      onFinish={onFinish}
                    > */}
                    <Row className="centerAlign justifyCSBetween">
                      <Col span={14} style={{ paddingRight: "5px" }}>
                        <div className="boxFormType">
                          <Form.Item
                            name={`rewinderreels${record?.orderno}`}
                            rules={[
                              {
                                required: true,
                                message: "This field is required.",
                              },
                              {
                                pattern: new RegExp(
                                  /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                                ),
                                message:
                                  "This value should be a non-zero positive value.",
                              },
                            ]}
                            className="dBlock"
                            initialValue={text}
                          >
                            <Input
                              onChange={(e) => {
                                onPlannedReelChange(e, record, index);
                              }}
                            />
                          </Form.Item>
                          <span
                            className="nonEditable"
                            style={{ marginTop: "0px" }}
                          >
                            {"Reels"}
                          </span>
                        </div>
                      </Col>
                      <Col
                        span={10}
                        style={{ paddingRight: "5px", marginTop: "0px" }}
                      >
                        <div
                          className="boxFormType"
                          style={{ marginBottom: "0", marginTop: "7px" }}
                        >
                          {(!plannedReelErr?.[record.orderno] ||
                            (plannedReelErr?.[record.orderno] &&
                              !plannedReelErr?.[record.orderno].error)) && (
                              <Tooltip title={"Save the entered value"}>
                                <Button
                                  key="1"
                                  className="edit-btn"
                                  style={{
                                    padding: "0px",
                                    margin: "0px",
                                    width: "28px",
                                    border: "none",
                                    display: "inline-block",
                                    marginRight: "10px",
                                  }}
                                  onClick={() =>
                                    onPlannedReelActionChange(
                                      index,
                                      "save",
                                      record
                                    )
                                  }
                                >
                                  <Iconmoon
                                    icon="check"
                                    size={18}
                                    color="#3FBD61"
                                  />
                                </Button>
                              </Tooltip>
                            )}

                          <Tooltip title={"Remove the entered value"}>
                            <Button
                              key="2"
                              className="edit-btn"
                              style={{
                                padding: "0px",
                                margin: "0px",
                                width: "28px",
                                border: "none",
                                display: "inline-block",
                              }}
                              onClick={() =>
                                onPlannedReelActionChange(
                                  index,
                                  "remove",
                                  record
                                )
                              }
                            >
                              <Iconmoon icon="cancel" size={18} color="red" />
                            </Button>
                          </Tooltip>
                        </div>
                      </Col>
                    </Row>
                    {/* </Form> */}
                  </HaberForm>
                </Styled>
              </DetailFields>
            )}
        </div>
      ),
    },
    {
      title: "Planned Weight",
      dataIndex: "plannedWeight",
      width: "2.5%",
    },
    {
      title: "Delivery Date",
      dataIndex: "deliverydate",
      width: "3%",
      align: "left",
    },

    {
      title: "Priority",
      dataIndex: "priority",
      width: "3%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn">
          <Button
            style={{ cursor: "default" }}
            onClick={() => {
              handlePriorityChange(record);
            }}
            disabled={action == "view" || !record.checked}
          >
            <Iconmoon
              icon={record?.priority ? "correct" : "wrong"}
              size={16}
              color={record?.priority ? "#3FBD61" : "#a19f9d"}
            />
          </Button>
        </div>
      ),
      align: "left",
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      width: "3%",
      render: (text, record) => (
        <div className="actionBtn">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={record?.remarks}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button style={{ cursor: "default" }}>
                <Iconmoon icon="message" size={16} color="#EA655B" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "left",
    },
    // {
    //   title: "Progress",
    //   dataIndex: "progress",
    //   width: "2.5%",
    //   render: (text, record) => (
    //     <div className="progressLvl">
    //       <Styled>
    //         <Tooltip
    //           placement="bottomRight"
    //           title={`${record.completed} Reels produced
    //                     ${record.in_progress} Reels in production
    //                     ${record.pendingQuantity} pending for deckle match`}
    //           className="edit-tooltip"
    //           getPopupContainer={(triggerNode) => triggerNode}
    //         >
    //           <Progress
    //             percent={
    //               ((record.completed + record.in_production) /
    //                 parseFloat(record.quantity.split(" ")[0])) *
    //               100
    //             }
    //             success={{
    //               percent:
    //                 (record.completed /
    //                   parseFloat(record.quantity.split(" ")[0])) *
    //                 100,
    //             }}
    //             strokeColor={{
    //               "75%": "#cbe2cd",
    //               "100%": "#edebe9",
    //             }}
    //           />
    //         </Tooltip>
    //       </Styled>
    //     </div>
    //   ),
    //   align:'left',
    // },
    {
      title: "Actions",
      dataIndex: "action",
      width: "3%",
      render: (text, record) => (
        <div className="actionBtn">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"View details of this order"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button
                onClick={() => {
                  handleActions(record);
                }}
              >
                <Iconmoon icon="file-view" size={16} color="#A19F9D" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "left",
    },
  ];

  const fullColumnsHeadForSheets = [
    {
      title: "Select",
      dataIndex: "checked",
      width: "2%",
      fixed: "left",
      align: "left",
      render: (value, record, rowIndex) => (
        <div className="actionBtn">
          {record.isConflictingstate ? (
            <span style={{ paddingBottom: '4px', paddingLeft: "5px" }}> <Tooltip title={`Conflicting order, part of ${record.jobcards?.length} conflicting job cards`} placement="top" >
              <Iconmoon icon="info_new" size={16} color="#EA655B" />
            </Tooltip>
            </span>
          ) : (
            // Invisible placeholder to maintain layout
            <span style={{ width: "14px" }}></span>
          )}
          <Styled>
            <Tooltip
              placement="topRight"
              title={
                record?.priority ? "Priority orders cannot be deselected" : ""
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Checkbox
                checked={value}
                onChange={handleCheckboxChangeFactory(
                  record,
                  "checked",
                  tableContent,
                  setTableContent,
                  setSelectedOrders
                )}
                disabled={action === "view" || record.isConflictingstate}
              />
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    {
      title: "Po/So.No",
      dataIndex: "pono",
      width: "3%",
      fixed: "left",
      align: "left",
      render: (text, record) => (
        <span
          style={{
            whiteSpace: "normal",
            wordBreak: "break-word",
            lineHeight: "1.4",
          }}
        >
          {`${record.category === "so"
              ? toHandlePOName(record.sono)
              : toHandlePOName(record.pono)
            }`
            .match(/.{1,15}/g)
            ?.map((chunk, index) => (
              <span key={index}>
                {chunk}
                <br />
              </span>
            ))}
        </span>
      ),
    },
    {
      title: "Group No.",
      dataIndex: "groupno",
      width: "3%",
      fixed: "left",
      align: "left",
    },
    {
      title: "Order No",
      dataIndex: "orderno",
      width: "2%",
      fixed: "left",
    },
    {
      title: "PO Date",
      dataIndex: "podate",
      width: "3%",
      align: "left",
    },
    {
      title: "Customer",
      dataIndex: "customer_alias",
      width: "3%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          {record.category === "so" ? (
            "-"
          ) : (
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={`${record.customercode}-${record.customer_name}`}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                {record?.customer_alias || "-"}
              </Tooltip>
            </Styled>
          )}
        </div>
      ),
    },
    {
      title: "Consignee",
      dataIndex: "consignee_alias",
      width: "3%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          {record.category === "so" ? (
            "-"
          ) : (
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={`${record.consignee}-${record.consignee_name}`}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                {record?.consignee_alias || "-"}
              </Tooltip>
            </Styled>
          )}
        </div>
      ),
    },
    {
      title: (
        <div>
          Product Spec
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={
                `The product specification is in the ${format}`
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      dataIndex: "productspec",
      width: "4.5%",
    },
    {
      title: "Type",
      dataIndex: "type",
      width: "2%",
    },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "2.5%",
    },
    {
      title: "Order quantity",
      dataIndex: "quantityValue",
      width: "3.4%",
      align: "left",
      render: (text, record) => (
        <div>
          {record.quantityValue && record.quantityValue.includes("\n")
            ? record.quantityValue.split("\n").map((line, index) => (
              <div
                key={index}
                style={{ fontSize: index === 0 ? "smaller" : "default" }}
              >
                {line}
              </div>
            ))
            : record.quantityValue}
        </div>
      ),
    },
    {
      title: "Balance Quantity",
      dataIndex: "balance_qty",
      width: "7.4%",
    },
    // {
    //   title: "Planned Quantity",
    //   dataIndex: "plannedQuantity",
    //   width: "2.5%",
    // },
    // {
    //   title: "Planned Weight",
    //   dataIndex: "plannedWeight",
    //   width: "2.5%",
    // },

    // {
    //   title: "Pending Quantity",
    //   dataIndex: "plannedQuantity",
    //   width: "2.6%",
    // },
    // {
    //   title: "Pending Weight",
    //   dataIndex: "pendingWeight",
    //   width: "2.6%",
    // },

    {
      title: "Pending Quantity",
      dataIndex: "pendingQuant",
      width: "3.4%",
      align: "left",
      render: (text, record) => (
        record.isConflictingstate ? "ND" :
          <div>
            {record.pendingQuant && record.pendingQuant.includes("\n")
              ? record.pendingQuant.split("\n").map((line, index) => (
                <div
                  key={index}
                  style={{ fontSize: index === 0 ? "smaller" : "default" }}
                >
                  {line}
                </div>
              ))
              : record.pendingQuant}
          </div>
      ),
    },

    // {
    //   title: "Reel OD",
    //   dataIndex: "reelod",
    //   width: "2%",
    // },
    {
      title: "Delivery Date",
      dataIndex: "deliverydate",
      width: "3%",
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      width: "2%",
      render: (text, record) => (
        <div className="actionBtn">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={record?.remarks}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button style={{ cursor: "default" }}>
                <Iconmoon icon="message" size={16} color="#EA655B" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "left",
    },
    {
      title: "Priority",
      dataIndex: "priority",
      width: "1.9%",
      render: (text, record) => (
        <div className="actionBtn">
          <Button style={{ cursor: "default" }}>
            <Iconmoon
              icon={record?.priority ? "correct" : "wrong"}
              size={16}
              color={record?.priority ? "#3FBD61" : "#a19f9d"}
            />
          </Button>
        </div>
      ),
      align: "left",
    },
    {
      title: "Progress",
      dataIndex: "progress",
      width: "4%",
      render: (text, record) => {
        // console.log(record.order_type, record.type);
        // if(record.item_type && record.item_type === "order"){
        if (!record.isConflictingstate) {
          if (
            record?.order_type === "sheet" ||
            (record?.order_type === "reel" && record?.quantity_type === "weight")
          ) {
            const totalProd =
              ((record?.progressbar_info?.completed?.weight +
                record?.progressbar_info?.in_production?.weight) /
                (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
              100;
            const totalCompleted =
              (record?.progressbar_info?.completed?.weight /
                (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
              100;
            //const weightUnitKey =  ((record?.units && record?.units?.weight) ? capitalize(weightUnit[record.units.weight]?.displayName) : "T") ;
            return (
              <div className="progressLvl">
                <Styled>
                  <Tooltip
                    placement="bottomRight"
                    title={`${record?.progressbar_info?.completed
                        ? (record?.progressbar_info?.completed?.weight).toFixed(3)
                        : 0.0
                      } ${capitalize(
                        weightUnit[
                          record?.progressbar_info?.completed?.units?.weight
                        ].displayName
                      )} Weight produced
                          ${record?.progressbar_info?.in_production
                        ? (record?.progressbar_info?.in_production?.weight).toFixed(
                          3
                        )
                        : 0.0
                      } ${capitalize(
                        weightUnit[
                          record?.progressbar_info?.in_production?.units?.weight
                        ].displayName
                      )} Weight in production
                        ${record?.progressbar_info?.pending
                        ? (record?.progressbar_info?.pending?.weight).toFixed(
                          3
                        )
                        : 0.0
                      } ${capitalize(
                        weightUnit[record?.progressbar_info?.pending?.units?.weight]
                          .displayName
                      )} Weight pending for deckle match`}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Progress
                      percent={totalProd}
                      success={{
                        percent: totalCompleted,
                      }}
                      strokeColor={"#cbe2cd"}
                    />
                  </Tooltip>
                </Styled>
              </div>
            );
          } else {
            const production =
              ((record?.progressbar_info?.completed?.quantity +
                record?.progressbar_info?.in_production?.quantity) /
                (record?.no_of_reel_sheet -
                  record.cancelled_quantity?.quantity)) *
              100;
            const completed =
              (record?.progressbar_info?.completed?.quantity /
                (record?.no_of_reel_sheet -
                  record.cancelled_quantity?.quantity)) *
              100;

            return (
              <div className="progressLvl">
                <Styled>
                  <Tooltip
                    placement="bottomRight"
                    title={`${record?.progressbar_info?.completed
                        ? record?.progressbar_info?.completed?.quantity
                        : 0
                      } Reels produced
                          ${record?.progressbar_info?.in_production
                        ? record?.progressbar_info?.in_production
                          ?.quantity
                        : 0
                      } Reels in production
                          ${record?.progressbar_info?.pending
                        ? record?.progressbar_info?.pending?.quantity
                        : 0
                      } Reels pending for deckle match`}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Progress
                      percent={production}
                      success={{
                        percent: completed,
                      }}
                      strokeColor={"#cbe2cd"}
                    />
                  </Tooltip>
                </Styled>
              </div>
            );
          }
        }
      },
      align: "center",
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "1.9%",
      render: (text, record) => (
        <div className="actionBtn">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"View details of this order"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button
                onClick={() => {
                  handleActions(record);
                }}
              >
                <Iconmoon icon="file-view" size={16} color="#A19F9D" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "left",
    },
  ];

  const filteredColumns1 = fullColumnsHead.filter(
    (col) => !columnBlacklist.includes(col.dataIndex) && (orderManagementSettings?.fetch_balance_quantity?.value || col.dataIndex != "balance_qty")
  );
  const filteredColumns2 = fullColumnsHeadForSheets.filter(
    (col) => !columnBlacklist.includes(col.dataIndex) && (orderManagementSettings?.fetch_balance_quantity?.value || col.dataIndex != "balance_qty")
  );

  const columnsHead = filteredColumns1;
  const columnsHeadForSheets = filteredColumns2;

  const saveOrder = (index, data) => {
    let quantityKey = 0;
    let plannedSheetsValue = 0;
    let reelODArr = [];
    if (
      (data.reelod && data.reelod.length == 1) ||
      (data.type?.toLowerCase() == "reel" && data.quantity_type == "reel_sheet")
    ) {
      quantityKey = parseFloat(data?.rewinderreels);
    }
    if (
      data.quantity_type == "reel_sheet" &&
      data.type.toLowerCase() == "sheet"
    ) {
      plannedSheetsValue = parseFloat(data.plannedQuant);
    }

    let plannedWeightValue = 0;
    if (
      ((((data.coreid &&
        data.coreid != "-" &&
        data.reelod &&
        data.reelod.length == 1) ||
        ((!data.coreid || data.coreid == "-") &&
          data.reelod &&
          data.reelod.length == 0) ||
        ((!data.coreid || data.coreid == "-") &&
          data.reelod &&
          data.reelod.length == 1) ||
        (data.coreid &&
          data.coreid != "-" &&
          data.reelod &&
          data.reelod.length == 0)) &&
        data.type?.toLowerCase() == "sheet") ||
        (((data.coreid &&
          data.coreid != "-" &&
          ((data.reelod && data.reelod.length == 1) ||
            (data.reelod &&
              data.quantity_type == "reel_sheet" &&
              data.type?.toLowerCase() == "reel"))) ||
          ((!data.coreid || data.coreid == "-") &&
            ((data.reelod && data.reelod.length == 0) ||
              (!data.reelod &&
                data.quantity_type == "reel_sheet" &&
                data.type?.toLowerCase() == "reel")) &&
            data.quantity_type != "weight") ||
          ((!data.coreid || data.coreid == "-") &&
            ((data.reelod && data.reelod.length == 0) ||
              (!data.reelod &&
                data.quantity_type == "reel_sheet" &&
                data.type?.toLowerCase() == "reel")) &&
            data.quantity_type != "weight")) &&
          data.type?.toLowerCase() == "reel")) &&
      data.id_od_type == "constant"
    ) {
      plannedWeightValue = parseFloat(data?.plannedWeight?.split(" ")[0]);
    } else if (
      (((data.reelod && data.reelod.length > 1) ||
        (data.coreid && data.coreid != "-")) &&
        data.quantity_type == "weight" &&
        data.id_od_type == "constant") ||
      (data.quantity_type == "weight" && data.id_od_type == "range")
    ) {
      plannedWeightValue = data.plannedQuant
        ? parseFloat(data.plannedQuant)
        : 0;
    } else if (
      (data.id_od_type == "range" && data.quantity_type != "weight") ||
      (data.reelod &&
        data.reelod.length > 1 &&
        data.quantity_type == "reel_sheet" &&
        data.id_od_type == "constant" &&
        data.type?.toLowerCase() == "sheet")
    ) {
      plannedWeightValue = 0;
    }

    let body = {
      type: data.type?.toLowerCase(),
      length: data?.length ? parseFloat(data.length) : 0,
      width: data?.width ? parseFloat(data.width) : 0,
      ...(data.quantity_type === "weight" && {
        weight: parseFloat(data.weight),
      }),
      product: data?.productcode,
      quantity_type: data.quantity_type === "weight" ? "weight" : "reel_sheet",
      ...(data.quantity_type !== "weight" && {
        no_of_reel_sheet:
          data.no_of_reel_sheet && data.no_of_reel_sheet != "-"
            ? parseFloat(data.no_of_reel_sheet)
            : 0,
      }),
      planned_weight: plannedWeightValue,
      // planned_weight: (data.reelod && data.reelod.length == 1 && data.id_od_type == "constant") ?  parseFloat(data?.plannedweight.split(" ")[0]) : (data.quantity_type === "weight" ?  parseFloat(data.plannedQuant) : 0),
      quantity: quantityKey,
      ...(data.quantity_type === "weight" && {
        planning_weight: data.plannedQuant ? parseFloat(data.plannedQuant) : 0,
      }),
      ...(data.quantity_type !== "weight" && {
        planning_quantity: data.plannedQuant
          ? parseFloat(data.plannedQuant)
          : 0,
      }),
      planned_sheets: plannedSheetsValue,
      net_price: data.net_price ? parseFloat(data.net_price) : 0,
      dealer_price: data.price ? parseFloat(data.price) : 0,
      customer_price: data?.customer_price
        ? parseFloat(data.customer_price)
        : 0,
      id_od_type: data.id_od_type,
      inner_dia: data.coreid && data.coreid != "-" ? data.coreid : "",
      ...(data.id_od_type == "constant" && {
        outer_dia: data.reelod && data.reelod != "-" ? data.reelod : reelODArr,
      }),
      ...(data.id_od_type == "range" && {
        minimum_reel_od: data.minimum_reel_od
          ? parseFloat(data.minimum_reel_od)
          : 0,
      }),
      ...(data.id_od_type == "range" && {
        maximum_reel_od: data.maximum_reel_od
          ? parseFloat(data.maximum_reel_od)
          : 0,
      }),
      units: {
        ...data?.units,
        ...(data.id_od_type == "range" && {
          minimum_reel_od: data.units?.minimum_reel_od,
        }),
        ...(data.id_od_type == "range" && {
          maximum_reel_od: data.units?.maximum_reel_od,
        }),
      },
      grain: data.grain
        ? data.grain == "Short" || data.grain == "short"
          ? "short"
          : "long"
        : null,
    };
    // console.log({body: body});

    updateOrder(data.orderno, body, "deckleRecord")
      .then((response) => {
        setActionToaster({
          error: response.error,
          msg: `Changes are successfully saved to Order ${data.orderno}`,
        });
        setRendering(!rendering);
        showToaster();
      })
      .catch((error) => {
        console.log("Error in updating order:", error?.response?.data);
        setActionToaster({
          error: error.response.data.error,
          msg: error.response.data.msg,
        });
        setRendering(!rendering);
        showToaster();
      });
  };

  const handleSaveTolerance = async () => {
    try {
      let body = {
        group: groupId,
        type: "order_level",
        upper_tolerance: parseFloat(upperTolerance),
        lower_tolerance: parseFloat(lowerTolerance),
        order: [selectedRecord.orderno.toString()],
        units: { "weight": location?.state?.data?.units?.weight }
      }
      const response = await editToleranceForOrderSummary(body)
      if (!response.error) {
        const updatedGroupsData = location.state?.data?.groups.map((group) => {
          if (group.id == groupId) {
            return { ...group, toleranceLevel: "Order", lower_bound_percentage: null, upper_bound_percentage: null };
          }
          else
            return group;
        })

        setFinalData({ ...finalData, "groups": updatedGroupsData })
        setOrderSummaryTable((prevState) => ({
          ...prevState,
          state: {
            ...prevState?.state,
            data: {
              ...prevState?.state?.data,
              groups: updatedGroupsData,
            }
          },
        }));

        const updatedRecords = tableContent.map((record) => {
          if (record.id == selectedRecord.id)
            return {
              ...record,
              calculated_lower_tolerance: parseFloat(lowerTolerance).toFixed(3),
              calculated_upper_tolerance: parseFloat(upperTolerance).toFixed(3)
            };
          else
            return record;
        })
        setTableContent(updatedRecords);
        setActionToaster({
          error: false,
          msg: `Tolerance Updated for Record ${selectedRecord.orderno}`
        })
        showToaster();
      }
      setEditTolerance(false);
    }
    catch (e) {
      console.log(e);
      setActionToaster({
        error: true,
        msg: `Unable to update Tolerance of order ${selectedRecord.orderno}`
      })
      showToaster();
    }
  }


  const handleDiscardTolerance = () => {
    setEditTolerance(false);
    setSelectedRecord(null);
    setEditColumn(null);
  }

  useEffect(() => {
    return () => {
      if (!nextClickRef.current) cancelJobCard();
      if (isCancelJobCard.current) setFormObject(null);
      if (!isBackClick.current)
        localStorage.setItem(
          "scrollCords",
          JSON.stringify({
            scrollX: 0,
            scrollY: 0,
          })
        );
    };
  }, []);
  // useEffect(() => {}, [selectedQty]);


  useEffect(() => {
    setLowerTolerance(selectedRecord?.calculated_lower_tolerance)
    setUpperTolerance(selectedRecord?.calculated_upper_tolerance)
  }, [selectedRecord])
  useEffect(() => {
    // getJobCardsById(jobId)
    //   .then((response) => {
    //     setJobCardOrders(response.jobcard.group.orders);
    //   })
    //   .catch((error) => console.log("error", error));

    // getOrdersData()
    //   .then((response) => {
    //     setOrdersList(response);
    //   })
    //   .catch((error) => console.log("error", error));

    // getPosData()
    //   .then((response) => {
    //     setPosList(response);
    //   })
    //   .catch((error) => console.log("error", error));

    // getProductsData()
    //   .then((response) => {
    //     setProductList(response);
    //   })
    //   .catch((error) => console.log("error", error));
    if (orderIdList.length) {
      setLoading(true);
      let req = {
        flow_type: machineData.planningType == 'purchaseOrder' ? 'po' : 'quality',
        jobcard_type: machineData.processType == 'multiStage' ? 'multi_stage' : 'single_stage',
        group_id: groupId,
        machine_data: machineData.processType == 'multiStage' && machineData.planningType == 'purchaseOrder' ? machineData.machine_data : machineData,
        filter: appliedFilters,
        fetch_type: selectedState,
        dummy_orders: location.state.isDummyJC,
        so_number: location.state.so,
        // jobcard_id: jobId,
      };
      getOrdersListForCreateNewSol(req, searchValue)
        .then((response) => {
          setOrdersList(response.data);
          let selectedOrderUnit;
          // let isMergedGroupUpdated = false;

          let totalPendingWeight = 0;
          setTotalOrders(response.data.length);
          for (const item of response.data) {
            if (orderIdList.includes(item.number)) {
              totalPendingWeight += item.planned_weight * conversionFactorUnitsToTonne[item.units.planned_weight];
              selectedOrderUnit = capitalize(
                weightUnit[item.units.planned_weight]?.displayName
              );
            }
          }
          const formattedSelectedQty =
            (totalPendingWeight).toFixed(3);
          setSelectedQty(formattedSelectedQty);

          setEmptyStateLabel("noData");
        })
        .catch((error) => {
          console.log("error", error);
          setEmptyStateLabel("connectionAPIError");
        })
        .finally(() => {
          setLoading(false);
        });

      return () => {
        // setJobCardOrders([]);
        setOrdersList([]);
        setTableContent([]);
        // setPosList([]);
        // setProductList([]);
      };
    }
  }, []);

  useEffect(() => {
    (async () => {
      let orderMangtSettings = await getWorkflowSettings("order_management");
      setOrderManagementSettings(orderMangtSettings?.data);
      await getUnitData().then((response) => {
        setUnitData(response.data);

        setSelectedWeightUnit(response.data.units_management.weight.default);

      })
        .catch((error) => {
          console.log(error);
        });
    })();
  }, []);

  useEffect(() => {
    let updatedTableContent = ordersList ? getAllOrders() : [];
    setTotalRecords(updatedTableContent.length);
    if (selectedState == 'unselected') {
      updatedTableContent = updatedTableContent
        .filter((item) => !item.checked)
    }

    setSelectedOrders(
      updatedTableContent
        .filter((item) => item.checked == true)
        .map((item) => item.orderno)
    );
    setTotalRecords(updatedTableContent.length);

    setTableContent(updatedTableContent);
  }, [ordersList]);

  useEffect(() => {
    if (grainType && selectedRecord && selectedIndex != null) {
      const updatedTableContent = [...tableContent];
      const updatedSelectedOrders = [...selectedOrders];

      const selectedRowIndex = updatedTableContent.findIndex(
        (item) => item.id === selectedRecord.id
      );
      if (selectedRowIndex !== -1) {
        let odType, reelUnit, reelod;
        updatedTableContent[selectedRowIndex].grain = grainType;
        updatedSelectedOrders[selectedRowIndex] = {
          ...updatedSelectedOrders[selectedRowIndex],
          grain: grainType,
        };
        const record = updatedTableContent[selectedRowIndex];
        let plannedQty = record.plannedQuant.split(" ")[0];
        plannedQty *=
          record.quantity_type === "weight"
            ? conversionFactorUnitsToTonne[record.units.planned_weight]
            : 1;
        odType = record.od_type;
        if (record.id_od_type === "range") {
          reelod = {
            minimum_reel_od: record.minimum_reel_od,
            maximum_reel_od: record.maximum_reel_od,
          };
          reelUnit = {
            minimum_reel_od: record?.units?.minimum_reel_od,
            maximum_reel_od: record?.units?.maximum_reel_od,
          };
        } else {
          reelod = record.outer_dia;
        }

        let weight;
        // console.log(odType, record);
        if (
          odType === "constant" &&
          reelod.length === 1 &&
          reelod[0] !== "0 cm" &&
          record.coreid !== "0 cm"
        ) {
          const reelodcm =
            parseFloat(reelod[0].split(" ")[0]) *
            orderDim_Rewinder_Unit_Conversion[reelod[0].split(" ")[1]];
          // console.log(reelodcm);
          const coreidcm =
            parseFloat(record.coreid.split(" ")[0]) *
            orderDim_Rewinder_Unit_Conversion[record.coreid.split(" ")[1]];
          // console.log(
          //   coreidcm,
          //   record.coreid,
          //   record.coreid.split(" ")[0],
          //   orderDim_Rewinder_Unit_Conversion[record.coreid.split(" ")[1]]
          // );
          weight = calcPlannedWeight(
            record,
            odType,
            reelodcm,
            plannedQty,
            coreidcm
          );
        } else if (
          // odType === "range" &&
          record.type === "Sheet" &&
          record.quantity_type === "reel_sheet"
        ) {
          weight = parseFloat(
            parseFloat(
              record.width *
              orderDim_Rewinder_Unit_Conversion[record?.units?.width] *
              parseFloat(plannedQty) *
              record.gsm *
              record.length *
              orderDim_Rewinder_Unit_Conversion[record?.units?.width]
            ) / 10000000000
          );
        } else weight = parseFloat(plannedQty);
        weight =
          weight * conversionFactorTonneToUnits[record.units.planned_weight];
        updatedTableContent[selectedRowIndex].plannedQuant = weight;
        updatedSelectedOrders[selectedRowIndex] = {
          ...updatedSelectedOrders[selectedRowIndex],
          plannedQuant: weight,
        };
        saveOrder(selectedIndex, updatedTableContent[selectedRowIndex]);
        setTableContent(updatedTableContent);
        setSelectedOrders(updatedSelectedOrders);
      }

      setGrainType("");
    }
  }, [selectedIndex, selectedRecord, grainType, selectedOrders, tableContent]);

  useEffect(() => {
    setLoading(true);
    let req = {
      flow_type: machineData.planningType == 'purchaseOrder' ? 'po' : 'quality',
      jobcard_type: machineData.processType == 'multiStage' ? 'multi_stage' : 'single_stage',
      group_id: groupId,
      machine_data: machineData.processType == 'multiStage' && machineData.planningType == 'purchaseOrder' ? machineData.machine_data : machineData,
      filter: appliedFilters,
      fetch_type: selectedState,
      dummy_orders: location.state.isDummyJC,
      so_number: location.state.so,
      //jobcard_id: jobId,
    };
    getOrdersListForCreateNewSol(req, searchValue)
      .then((response) => {
        setOrdersList(response.data);
        setEmptyStateLabel("filter");
      })
      .catch((error) => {
        console.log("error", error);
        setEmptyStateLabel("connectionAPIError");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [appliedFilters, rendering]);


  useEffect(() => {
    if (rendering) {
      setLoading(true);
      let req = {
        flow_type: machineData.planningType == 'purchaseOrder' ? 'po' : 'quality',
        jobcard_type: machineData.processType == 'multiStage' ? 'multi_stage' : 'single_stage',
        group_id: groupId,
        machine_data: machineData.processType == 'multiStage' && machineData.planningType == 'purchaseOrder' ? machineData.machine_data : machineData,
        filter: appliedFilters,
        fetch_type: selectedState,
        dummy_orders: location.state.isDummyJC,
        so_number: location.state.so,
        //jobcard_id: jobId,
      };
      getOrdersListForCreateNewSol(req, searchValue)
        .then((response) => {
          setOrdersList(response.data);
          setEmptyStateLabel("filter");
        })
        .catch((error) => {
          console.log("error", error);
          setEmptyStateLabel("connectionAPIError");
        })
        .finally(() => {
          setLoading(false);
        });
      setRendering(false)
    }
  }, [rendering]);

  useEffect(() => {
    let propsData = {};
    if (emptyStateLabel === "noData") {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records in this list";
      propsData["subHeading"] =
        "There are no records to show in this list. Add new records to view details here ";
    } else if (emptyStateLabel === "search") {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records found";
      propsData["subHeading"] =
        "There is no record matching your search keyword. Try adjusting your search to find what you are looking for.";
    } else if (emptyStateLabel === "filter") {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records found";
      propsData["subHeading"] =
        "There is no record matching your filter. Try changing your filter to find what you are looking for.";
    } else {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "Something went wrong";
      propsData["subHeading"] =
        "Check your internet connection or try reloading the page.";
    }
    setEmptyStatePropsData(propsData);
  }, [emptyStateLabel]);
  useEffect(() => {
    if (editColumn == "Tolerance Level")
      validateTolerance();
  }, [lowerTolerance, upperTolerance])


  useEffect(() => {
    const filteredColumns1 = fullColumnsHead.filter(
      (col) => !columnBlacklist.includes(col.dataIndex)
    );
    const filteredColumns2 = fullColumnsHeadForSheets.filter(
      (col) => !columnBlacklist.includes(col.dataIndex)
    );

    columnsHead.current = filteredColumns1;
    columnsHeadForSheets.current = filteredColumns2;

    setTableRerender(false);
  }, [tableRerender])


  useEffect(() => {
    setLowerTolerance(selectedRecord?.calculated_lower_tolerance)
    setUpperTolerance(selectedRecord?.calculated_upper_tolerance)
  }, [selectedRecord])


  return (
    tableContent && (
      <RightLayoutContainer id="right-layout-container">
        <PageTitleComp ref={titleRef} style={{ position: "sticky", top: stickyOffsets.title, zIndex: 100, backgroundColor: "#fff" }}>
          <PageHeader
            ghost={false}
            title="Review Selected Orders"
            extra={[
              action === "edit" ? (
                <Button
                  key="confirm"
                  className="themeBtn"
                  onClick={onConfirmGroup}
                >
                  Confirm Group
                </Button>
              ) : (
                <Button
                  key="edit"
                  className="themeBtn"
                  onClick={onEditClick}
                >
                  <Iconmoon icon="edit" size={14} color="#ffffff" />
                  Edit Group
                </Button>
              )

            ]}
          ></PageHeader>
        </PageTitleComp>
        <Form
          form={form}
          name="basic"
          autoComplete="off"
          className="haberLogin"
          onFinishFailed={(error) => {
            console.log("Form Error", error);
          }}
          initialValues={{
            remember: true,
          }}
        >
          <TableLayoutData>
            <div className="tableDataFormat ">
              {action == 'view' && <ReviewSelectedHeader
                totalOrders={orderIdList.length}
                selectedOrders={selectedOrders.length}
                routeBack={routeBack}
                selectedQuantity={selectedQty}
                weightUnit={selectedWeightUnit}
              />
              }
              {action == 'edit' && <DetailFields style={{ paddingBottom: "0px" }}>
                <HaberForm>
                  <div className="groupDetailWrap">
                    <Row>
                      <Col style={{ width: "70%" }}>
                        <SearchContainer
                          placeholder={"Search Order or PO Number"}
                          fetchOrder={searchOrders}
                          clearSearch={clearSearch}
                          setClearSearch={setClearSearch}
                          searchedValue={searchValue}
                          //ismachineOrderSearch={true}

                          isSelectedOrder={true}
                          hideExport={true}
                        />
                      </Col>
                      <Col style={{ width: "30%" }} className="blockBreak">
                        <div
                          className="boxFormType unitSelect"
                          style={{
                            marginBottom: "0",
                            width: "200px",
                            float: "right",
                            paddingTop: "17px",
                          }}
                        >
                          <Form.Item
                            name="length_unit"
                            initialValue={selectedState}
                          >
                            <Select
                              placeholder="Unit"
                              suffixIcon={<DownArrowDraw />}
                              onChange={onDropdownFilterChange}
                              value={selectedState}
                            >
                              {filterType.map((type) => (
                                <Option key={type.value}>{type.label}</Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </div>
                      </Col>
                    </Row>

                    <Row
                      gutter={{ xs: 1, sm: 3, md: 6, lg: 12 }}
                      style={{ marginBottom: "20px", marginTop: "15px" }}
                    >
                      <Col style={{ width: "60%" }}>
                        <Row
                          gutter={{ xs: 1, sm: 3, md: 6, lg: 12 }}
                          style={{
                            marginLeft: "-30px",
                            marginBottom: "-10px",
                          }}
                        >
                          <Col
                            className="gutter-row"
                            style={{
                              width: "auto",
                              marginBottom: "10px",
                              paddingLeft: "0px",
                              paddingRight: "0px",
                            }}
                          >
                            {" "}
                            <OrderFilter
                              filterType={{
                                key: 8,
                                label: "Filter by GSM",
                                value: "gsm",
                                type: "inputSelect",
                                name: "GSM",
                              }}
                              applyFilter={applyfilter}
                            ></OrderFilter>
                          </Col>
                          <Col
                            className="gutter-row"
                            style={{
                              width: "auto",
                              marginBottom: "10px",
                              paddingLeft: "0px",
                              paddingRight: "0px",
                            }}
                          >
                            {" "}
                            <OrderFilter
                              filterType={{
                                key: 8,
                                label: "Filter by Burst Factor",
                                value: "burst_factor",
                                type: "inputSelect",
                                name: "BF",
                              }}
                              applyFilter={applyfilter}
                            ></OrderFilter>
                          </Col>

                          <Col
                            className="gutter-row"
                            style={{
                              width: "auto",
                              marginBottom: "10px",
                              paddingLeft: "0px",
                              paddingRight: "0px",
                            }}
                          >
                            {" "}
                            <OrderFilter
                              filterType={{
                                key: 8,
                                label: "Filter by Size",
                                value: "size",
                                type: "rangeTypeSelect",
                                unitType: "length",
                                name: "Size",
                              }}
                              applyFilter={applyfilter}
                            ></OrderFilter>
                          </Col>
                          <Col
                            className="gutter-row"
                            style={{
                              width: "auto",
                              marginBottom: "10px",
                              paddingLeft: "0px",
                              paddingRight: "0px",
                            }}
                          >
                            {" "}
                            <OrderFilter
                              filterType={{
                                key: 8,
                                label: "Filter by Customer",
                                value: "customer",
                                type: "multiSelect",
                                name: "Customer",
                              }}
                              applyFilter={applyfilter}
                            ></OrderFilter>
                          </Col>
                        </Row>
                      </Col>
                      <Col style={{ width: "40%" }}>
                        <OrderDetails style={{ height: "100%" }}>
                          <div
                            className="pendingDetailsStyle"
                            style={{
                              paddingBottom: "0px",
                              paddingTop: "10px",
                            }}
                          >
                            <span className="pendingOrderStyle">
                              {" "}
                              Total Orders:{" "}
                              {totalOrders}
                            </span>{" "}
                            <span className="pendingOrderStyle">
                              {" "}
                              Selected Orders:{" "}
                              {orderIdList?.length ? orderIdList.length : 0}
                            </span>{" "}
                            Selected Quantity: {!selectedQty || !selectedWeightUnit ? 0 : ((selectedQty * conversionFactorTonneToUnits[selectedWeightUnit]) + ' ' + capitalize(selectedWeightUnit))}
                          </div>
                        </OrderDetails>
                      </Col>
                    </Row>
                    {filterTags.map((filter) => (
                      // <Tooltip
                      //   placement="bottomRight"
                      //   title={filter.tooltip || ""}
                      //   className="edit-tooltip"
                      //   getPopupContainer={(triggerNode) => triggerNode}
                      // >
                      <span className="filter-tags">
                        <Iconmoon icon="filter" size={13} color="#a8a8a8" />
                        &nbsp;
                        <span>{filter.formattedType}</span>
                        &nbsp;
                        <span>{filter.operand}</span>
                        &nbsp;
                        <span>{filter.value}</span>
                        <span>
                          {" "}
                          <button
                            onClick={() => {
                              removeFilter(filter);
                            }}
                          >
                            {" "}
                            <Iconmoon icon="wrong" size={15} color="#a8a8a8" />{" "}
                          </button>
                        </span>
                        <Styled></Styled>
                      </span>
                      // </Tooltip>
                    ))}
                  </div>
                </HaberForm>
              </DetailFields>
              }

              {loading ? (
                <TableShimmer
                  // header={
                  //   (
                  //     location?.state?.processType === "multiStage"
                  //       ? columnsHead
                  //       : location?.state?.selected_type === "cutting"
                  //       ? columnsHeadForSheets
                  //       : columnsHead.filter((col) => col.title !== "Grain")
                  //   ).filter((col) => !(action === "view" && col.title === "Select"))
                  // }
                  header={
                    location?.state?.processType === "multiStage"
                      ? (
                        orderManagementSettings?.fetch_balance_quantity?.value
                          ? columnsHead
                          : columnsHead?.filter((col) => col.dataIndex !== "balance_qty")
                      ).filter((col) => !(action === "view" && col.title === "Select"))
                      : location?.state?.selected_type === "cutting"
                        ? (
                          orderManagementSettings?.fetch_balance_quantity?.value
                            ? columnsHeadForSheets
                            : columnsHeadForSheets?.filter((col) => col.dataIndex !== "balance_qty")
                        ).filter((col) => !(action === "view" && col.title === "Select"))
                        : (
                          (orderManagementSettings?.fetch_balance_quantity?.value
                            ? columnsHead
                            : columnsHead?.filter((col) => col.dataIndex !== "balance_qty"))
                            ?.filter((col) => col.title !== "Grain")
                        ).filter((col) => !(action === "view" && col.title === "Select"))
                  }
                  scroll={2000}
                />
              ) : tableContent?.length ? (
                <Table
                  // columns={
                  //   (
                  //     location?.state?.processType === "multiStage"
                  //       ? columnsHead
                  //       : location?.state?.selected_type === "cutting"
                  //       ? columnsHeadForSheets
                  //       : columnsHead.filter((col) => col.title !== "Grain")
                  //   ).filter((col) => !(action === "view" && col.title === "Select"))
                  // }
                  columns={
                    location?.state?.processType === "multiStage"
                      ? (
                        orderManagementSettings?.fetch_balance_quantity?.value
                          ? columnsHead
                          : columnsHead?.filter((col) => col.dataIndex !== "balance_qty")
                      ).filter((col) => !(action === "view" && col.title === "Select"))
                      : location?.state?.selected_type === "cutting"
                        ? (
                          orderManagementSettings?.fetch_balance_quantity?.value
                            ? columnsHeadForSheets
                            : columnsHeadForSheets?.filter((col) => col.dataIndex !== "balance_qty")
                        ).filter((col) => !(action === "view" && col.title === "Select"))
                        : (
                          (orderManagementSettings?.fetch_balance_quantity?.value
                            ? columnsHead
                            : columnsHead?.filter((col) => col.dataIndex !== "balance_qty"))
                            ?.filter((col) => col.title !== "Grain")
                        ).filter((col) => !(action === "view" && col.title === "Select"))
                  }
                  dataSource={tableContent}
                  onChange={onChange}
                  pagination={{
                    current: currentPage,
                    total: totalRecords,
                    showTitle: false,
                    pageSize: paginationParams.size,
                    showTotal: (total, range) =>
                      `Showing ${range[0]}-${range[1]} of ${total} results`,
                    pageSizeOptions: [10, 20, 50, 100],
                    showSizeChanger: true,
                    // locale: { items_per_page: "" },
                  }}
                  scroll={{ x: 2020 }}
                  rowClassName={getRow}
                  sticky={{
                    offsetHeader: stickyOffsets.table,
                    getContainer: () => {
                      let node = document.getElementById('right-layout-container');
                      return node ? node : window;
                    }
                  }}
                />
              )
                : (
                  <EmptyState
                    img={
                      emptyStateLabel === "noData" || emptyStateLabel === "filter"
                        ? emptyState_NoData
                        : emptyStateLabel === "search"
                          ? emptyState_Search
                          : emptyState_ConnectionAPIError
                    }
                    heading={emptyStatePropsData?.heading}
                    subHeading={emptyStatePropsData?.subHeading}
                    label={emptyStatePropsData?.label}
                    refresh={refresh}
                  />
                )}
            </div>
          </TableLayoutData>
        </Form>
        {/* <span className="textTypeBtn textBtnIcon tonnesCount">
          Total Production Quantity of these group orders is {quantity}{" "}
          {location?.state?.selected_type === "cutting" ? "Sheets" : "Reels"}
        </span> */}

        <ViewDeckleOrder
          selectedOrderNo={selectedOrder?.orderno}
          // selectedOrderNo={1}
          showButton={false}
          visible={ReviewSelectedOrder}
          onClose={onCloseReviewSelectedOrder}
          onCloseGrade={onCloseFullReviewSelectedOrder}
          category={selectedOrder?.category}
        />

        <ConfirmationModal
          visible={deleteModal}
          icon={warning}
          confirmAction={modalConfirm}
          cancelAction={modalCancel}
        >
          <span>Are you sure?</span>
          <p>
            No orders are selected, this group will be deleted.
          </p>
        </ConfirmationModal>

        <ConfirmationModal
          visible={viewCancelModal}
          icon={warning}
          confirmAction={confirmCancelModal}
          cancelAction={closeCancelModal}
        >
          <span>Cancel job card?</span>
          <p>
            You are about to cancel the deckle match process. Are you sure you
            want to continue?
          </p>
        </ConfirmationModal>
        {visibleToaster && !actionToaster.error && (
          <AlertContainer
            color="green toaster"
            icon={alertGreen}
            msg={actionToaster.msg}
          />
        )}
        {visibleToaster && actionToaster.error && (
          <AlertContainer
            color="red toaster"
            icon={alertRed}
            msg={actionToaster.msg}
          />
        )}
        {editReelCoreModal && selectedRecord && (
          <ReelCoreEditModal
            visible={editReelCoreModal}
            icon={warning}
            confirmAction={confirmEditReelCoreModal}
            cancelAction={closeEditReelCoreModal}
            orderData={selectedRecord}
            type={selectedType}
          >
            <span></span>
            <p></p>
          </ReelCoreEditModal>
        )}

        <JobCardReelODEditModal
          visible={isJobCardReelODEditModalVisible}
          groupId={groupId}
          setIsJobCardReelODEditModalVisible={
            setIsJobCardReelODEditModalVisible
          }
          setGlobalReelOD={setGlobalReelOD}
          showToaster={showToaster}
          setActionToaster={setActionToaster}
          refresh={refresh}
          setShowAlert={setShowAlert}
        />
        <ConfirmationModal
          visible={viewConfirmGroupModal}
          icon={warning}
          param={null}
          confirmAction={() => {
            setViewConfirmGroupModal(false);
            routeBack();
          }}
          cancelAction={() => { setViewConfirmGroupModal(false) }}
        >
          <span>Are you sure you want to proceed?</span>
          <p>
            Some orders have custom Order-Level Reel OD values, but you've
            selected Job Card-Level OD.
          </p>
        </ConfirmationModal>
      </RightLayoutContainer>
    )
  );
};

export default ReviewSelectedOrdersData;
